webpackJsonp([1],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivilegeMixin__ = __webpack_require__(60);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommonMixin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__PrivilegeMixin__["a" /* default */]],
  data: function data() {
    return {
      validator: __WEBPACK_IMPORTED_MODULE_1__validation__["a" /* default */].createValidator(),
      api: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */]
    };
  },

  methods: {
    gotoOverviewWithFilter: function gotoOverviewWithFilter(name, filter) {
      this.$store.commit({ type: 'setFilter', name: name, value: filter });
      this.$router.push({ name: name });
    }
  }
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_accounting__);



function _formatDateTime(value) {
  return value == null ? '' : __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(value)).format('DD-MM-YYYY  HH:mm');
}
/* harmony default export */ __webpack_exports__["a"] = ({
  formatBoolean: function formatBoolean(value) {
    return value ? 'Yes' : 'No';
  },
  formatDate: function formatDate(value) {
    return value == null ? '' : __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(value)).format('DD-MM-YYYY');
  },
  formatDateTime: function formatDateTime(value) {
    return _formatDateTime(value);
  },
  formatTimeStamp: function formatTimeStamp(value) {
    return _formatDateTime(value);
  },
  formatMoney: function formatMoney(value) {
    if (value === null) return '';else {
      return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatMoney(value, '€', 2);
    }
  }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Contract',
  overviewTitle: 'Contracts',
  overviewRouterUrl: 'contracts',
  getFilterName: function getFilterName(context) {
    return 'contracts';
  },

  overviewApiUrl: '/contracts/',
  detailTitle: 'Contract Detail',
  detailRouterUrl: 'contract',
  detailApiUrl: '/contracts/',
  quickFilterName: 'Contract Nr',
  quickFilterField: 'number',
  advancedSearch: true,
  updateNewRecord: function updateNewRecord(context, rec) {
    rec.active = true;
    rec.bankinfo_required = true;
    rec.check_universityfee_payment = true;
    rec.instalments = false;
  },
  getDefaultFilter: function getDefaultFilter(context) {
    return {};
  },

  sortOrder: [{
    field: 'last_name',
    sortField: 'last_name',
    direction: 'asc'
  }],
  fields: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Application Number', name: 'application_number', sortField: 'application_number', link: '#/contract/{id}' }, { title: 'Student Name', name: 'student_name', sortField: 'student_name', link: '#/student/{student_id}' }, { title: 'Status', name: 'contract_status_name' }, { title: 'Code', name: 'scholarship_code' }, { title: 'Program', name: 'program_shortname' }, { title: 'Start Date', name: 'start_date', sortField: 'start_date', callback: 'formatDate' }, { title: 'End Date', name: 'end_date', sortField: 'end_date', callback: 'formatDate' }, { title: 'Contract Sent', name: 'contract_sent_date', sortField: 'contract_sent_date', callback: 'formatDate' }, { title: 'Bank Request', name: 'bankinfo_emailrequest_timestamp', sortField: 'bankinfo_emailrequest_timestamp', callback: 'formatDate' }, { title: 'Bank Updated', name: 'bankinfo_updated_timestamp', sortField: 'bankinfo_updated_timestamp', callback: 'formatDate' }, { title: 'PF Status Sent', name: 'pf_status_email_timestamp', sortField: 'pf_status_email_timestamp', callback: 'formatDate' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Country',
  overviewTitle: 'Countries',
  overviewRouterUrl: 'countries',
  getFilterName: function getFilterName(context) {
    return 'countries';
  },

  overviewApiUrl: '/countries/',
  detailTitle: 'Country Detail',
  detailRouterUrl: 'country',
  detailApiUrl: '/countries/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [{
    field: 'name',
    sortField: 'name',
    direction: 'asc'
  }],
  fields: [{ title: 'Code', name: 'cntry_code', sortField: 'cntry_code', link: '#/country/{id}' }, { title: 'Name', name: 'cntry_name', sortField: 'cntry_name', link: '#/country/{id}' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

function getSubType(context) {
  var path = context.$route.path;
  var expr = /\/invoices?\/([a-z]+).*/;
  var subtype = expr.exec(path)[1];
  console.assert(subtype);
  return subtype;
}

var filterParams = {
  planned: { planned: true },
  numbered: { numbered: true },
  creditnote: { creditnote: true }
};
var overviewTitles = {
  planned: 'Planned Invoices',
  numbered: 'Numbered Invoices',
  creditnote: 'Credit Notes'
};
var detailTitles = {
  planned: 'Planned Invoice',
  numbered: 'Numbered Invoice',
  creditnote: 'Credit Note'
};
var overviewRouterUrls = {
  planned: 'planned_invoices',
  numbered: 'numbered_invoices',
  creditnote: 'creditnote_invoices'
};
var detailRouterUrls = {
  planned: 'planned_invoice',
  numbered: 'numbered_invoice',
  creditnote: 'creditnote_invoice'
};

var fieldsMap = {
  planned: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Reference', name: 'document_reference', sortField: 'document_reference', link: '#/invoice/planned/{id}' }, { title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}' }, { title: 'Student Name', name: 'student_name' }, { title: 'Year', name: 'year', sortField: 'year' }, { title: 'Semester', name: 'semester', sortField: 'semester' }, { title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Description', name: 'description', sortField: 'description' }, { title: 'Planned Date', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate', dataClass: 'text-center' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp', dataClass: 'text-center' }, { title: 'Comments', name: 'comments', sortField: 'comments' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }],
  numbered: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Invoice Number', name: 'number', sortField: 'number', link: '#/invoice/numbered/{id}' }, { title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}' }, { title: 'Student Name', name: 'student_name' }, { title: 'Year', name: 'year', sortField: 'year' }, { title: 'Semester', name: 'semester', sortField: 'semester' }, { title: 'Amount invoiced', name: 'total_amount', sortField: 'total_amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Amount paid', name: 'payed_amount', sortField: 'payed_amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Date', name: 'invoice_date', sortField: 'invoice_date', callback: 'formatDate' }, { title: 'Exp. Date', name: 'expiration_date', sortField: 'expiration_date', callback: 'formatDate' }, { title: 'Ext. Deadline', name: 'extended_deadline_date', sortField: 'extended_deadline', callback: 'formatDate' }, { title: 'Email Sent', name: 'email_timestamp', sortField: 'email_timestamp', callback: 'formatDate' }, { title: 'Reminder Sent', name: 'email_reminder_timestamp', sortField: 'email_reminder_timestamp', callback: 'formatDate' }, { title: 'Credit Note', name: 'credit_note', sortField: 'credit_note' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: 'Comments', name: 'comments', sortField: 'comments' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }],
  creditnote: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Credit Note Number', name: 'number', sortField: 'number', link: '#/invoice/creditnote/{id}' }, { title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}' }, { title: 'Student Name', name: 'student_name' }, { title: 'Year', name: 'year', sortField: 'year' }, { title: 'Semester', name: 'semester', sortField: 'semester' }, { title: 'Amount credited', name: 'total_amount', sortField: 'total_amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Description', name: 'description', sortField: 'description' }, { title: 'Date', name: 'invoice_date', sortField: 'invoice_date', callback: 'formatDate' }, { title: 'Exp. Date', name: 'expiration_date', sortField: 'expiration_date', callback: 'formatDate' }, { title: 'Ext. Deadline', name: 'extended_deadline_date', sortField: 'extended_deadline', callback: 'formatDate' }, { title: 'Email Sent', name: 'email_timestamp', sortField: 'email_timestamp', callback: 'formatDate' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: 'Comments', name: 'comments', sortField: 'comments' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  overviewApiUrl: '/invoices/',
  deleteTitle: function deleteTitle(context) {
    return detailTitles[getSubType(context)];
  },
  disableDelete: function disableDelete(rec) {
    return rec.is_locked;
  },
  subType: function subType(context) {
    return getSubType(context);
  },
  overviewTitle: function overviewTitle(context) {
    return overviewTitles[getSubType(context)];
  },
  overviewRouterUrl: function overviewRouterUrl(context) {
    return overviewRouterUrls[getSubType(context)];
  },
  getFilterName: function getFilterName(context) {
    return overviewRouterUrls[getSubType(context)];
  },
  detailTitle: function detailTitle(context) {
    return detailTitles[getSubType(context)];
  },
  updateNewRoute: function updateNewRoute(context, route) {
    route.params.subtype = getSubType(context);
  },
  detailRouterUrl: function detailRouterUrl(context) {
    return detailRouterUrls[getSubType(context)];
  },
  updateNewRecord: function updateNewRecord(context, rec) {
    if (context.$route.params.subtype === 'creditnote') {
      rec.document_type_id = 2;
    } else {
      rec.document_type_id = 1;
    }
  },
  disableNew: function disableNew(context) {
    return getSubType(context) !== 'planned';
  },

  detailApiUrl: '/invoices/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  sortOrder: [{
    field: 'number',
    sortField: 'number',
    direction: 'asc'
  }],
  updateFilter: function updateFilter(context, params) {
    var subparams = filterParams[getSubType(context)];
    console.assert(subparams);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, subparams);
  },
  fields: function fields(context) {
    return fieldsMap[getSubType(context)];
  }
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Invoice Payment',
  overviewTitle: 'Invoice Payments',
  overviewRouterUrl: 'invoicepayments',
  getFilterName: function getFilterName(context) {
    return 'invoicepayments';
  },

  overviewApiUrl: '/invoice_payments/',
  detailTitle: 'Invoice Payment Detail',
  detailRouterUrl: 'invoicepayment',
  detailApiUrl: '/invoice_payments/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  updateNewRecord: function updateNewRecord(context, rec) {
    if (context.$route.query) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rec, context.$route.query);
    rec.commission = 0;
  },

  sortOrder: [{
    field: 'number',
    sortField: 'number',
    direction: 'asc'
  }],
  fields: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Payment ID', name: 'id', sortField: 'id', link: '#/invoicepayment/{id}' }, { title: 'Invoice Number', name: 'invoice', sortField: 'invoice', link: '#/invoice/numbered/{invoice_id}' }, { title: 'Contract', name: 'contract', sortField: 'contract.name' }, { title: 'Student Name', name: 'student_name' }, { title: 'Net Amount', name: 'net_amount', sortField: 'net_amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Commission', name: 'commission', sortField: 'commission', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Amount Paid', name: 'amount_paid', sortField: 'amount_paid', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Payment Date', name: 'payment_date', sortField: 'payment_date', callback: 'formatDate' }, { title: 'Payment Confirmation', name: 'payment_confirmation_timestamp', sortField: 'payment_confirmation_timestamp', callback: 'formatTimeStamp' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Milestone',
  overviewTitle: 'Milestone',
  overviewRouterUrl: 'milestones',
  getFilterName: function getFilterName(context) {
    return 'milestones';
  },

  overviewApiUrl: '/milestones/',
  detailTitle: 'Milestone Detail',
  detailRouterUrl: 'milestone',
  detailApiUrl: '/milestones/',
  quickFilterName: 'Intake',
  quickFilterField: 'name',
  advancedSearch: true,
  updateNewRecord: function updateNewRecord(context, rec) {
    rec.milestone_amount = 0.0;
  },
  getDefaultFilter: function getDefaultFilter(context) {
    return {};
  },

  sortOrder: [{
    field: 'intake',
    sortField: 'intake',
    direction: 'asc'
  }],
  fields: [{ title: 'Intake', name: 'intake', sortField: 'intake', link: '#/studentfee/{id}' }, { title: 'Scholarship', name: 'scholarship_code', sortField: 'scholarship_code' }, { title: 'Year', name: 'year', sortField: 'year' }, { title: 'Date', name: 'milestone_date', sortField: 'milestone_date', callback: 'formatDate' }, { title: 'Amount', name: 'milestone_amount', sortField: 'milestone_amount' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Program',
  overviewTitle: 'Programs',
  overviewRouterUrl: 'programs',
  getFilterName: function getFilterName(context) {
    return 'programs';
  },

  overviewApiUrl: '/programs/',
  detailTitle: 'Program Detail',
  detailRouterUrl: 'program',
  detailApiUrl: '/programs/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [{
    field: 'name',
    sortField: 'name',
    direction: 'asc'
  }],
  fields: [{ title: 'Name', name: 'name', sortField: 'name', link: '#/program/{id}' }, { title: 'Short Name', name: 'shortname', sortField: 'shortname' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

function getSubType(context) {
  var path = context.$route.path;
  var expr = /\/scholarshippayments?\/([a-z]+).*/;
  var subtype = expr.exec(path)[1];
  console.assert(subtype);
  return subtype;
}

var filterParams = {
  planned: { planned: true },
  numbered: { numbered: true }
};
var overviewTitles = {
  planned: 'Planned Payments',
  numbered: 'Numbered Payments'
};
var detailTitles = {
  planned: 'Planned Payment',
  numbered: 'Numbered Payment'
};
var overviewRouterUrls = {
  planned: 'planned_scholarshippayments',
  numbered: 'numbered_scholarshippayments'
};
var detailRouterUrls = {
  planned: 'planned_scholarshippayment',
  numbered: 'numbered_scholarshippayment'
};

var fieldsMap = {
  planned: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Contract', name: 'contract', link: '#/contract/{contract_id}' }, { title: 'Student', name: 'student_name' }, { title: 'Type', name: 'scholarship_payment_type', sortField: 'scholarship_payment_type' }, { title: 'Period', name: 'period', sortField: 'period' }, { title: 'Amount', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Planned', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: 'Comments', name: 'comments', sortField: 'comments' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }],
  numbered: [{ title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center' }, { title: 'Number', name: 'number', sortField: 'number', link: '#/scholarshippayment/numbered/{id}' }, { title: 'Contract', name: 'contract', link: '#/contract/{contract_id}' }, { title: 'Student', name: 'student_name' }, { title: 'Type', name: 'scholarship_payment_type', sortField: 'scholarship_payment_type' }, { title: 'Period', name: 'period', sortField: 'period' }, { title: 'Amount', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right' }, { title: 'Planned', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate' }, { title: 'Payment Date', name: 'payment_date', sortField: 'payment_date', callback: 'formatDate' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { title: 'Exported', name: 'exported_timestamp', sortField: 'exported_timestamp', callback: 'formatTimeStamp' }, { title: 'Export Allowed', name: 'payment_allowed', sortField: 'payment_allowed' }, { title: 'Comments', name: 'comments', sortField: 'comments' }, { title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center' }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  overviewApiUrl: '/scholarship_payments/',
  deleteTitle: function deleteTitle(context) {
    return detailTitles[getSubType(context)];
  },
  subType: function subType(context) {
    return getSubType(context);
  },
  overviewTitle: function overviewTitle(context) {
    return overviewTitles[getSubType(context)];
  },
  overviewRouterUrl: function overviewRouterUrl(context) {
    return overviewRouterUrls[getSubType(context)];
  },
  getFilterName: function getFilterName(context) {
    return overviewRouterUrls[getSubType(context)];
  },
  detailTitle: function detailTitle(context) {
    return detailTitles[getSubType(context)];
  },
  updateNewRoute: function updateNewRoute(context, route) {
    route.params.subtype = getSubType(context);
  },
  detailRouterUrl: function detailRouterUrl(context) {
    return detailRouterUrls[getSubType(context)];
  },
  updateNewRecord: function updateNewRecord(context, rec) {},
  disableNew: function disableNew(context) {
    return getSubType(context) !== 'planned';
  },

  detailApiUrl: '/scholarship_payments/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  sortOrder: [{
    field: 'number',
    sortField: 'number',
    direction: 'asc'
  }],
  updateFilter: function updateFilter(context, params) {
    var subparams = filterParams[getSubType(context)];
    console.assert(subparams);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, subparams);
  },
  fields: function fields(context) {
    return fieldsMap[getSubType(context)];
  }
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Student',
  overviewTitle: 'Students',
  overviewRouterUrl: 'students',
  getFilterName: function getFilterName(context) {
    return 'students';
  },

  overviewApiUrl: '/students/',
  detailTitle: 'Student Detail',
  detailRouterUrl: 'student',
  detailApiUrl: '/students/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: true,
  sortOrder: [{
    field: 'last_name',
    sortField: 'last_name',
    direction: 'asc'
  }],
  fields: [{ title: 'First Name', name: 'first_name', sortField: 'first_name', link: '#/student/{id}' }, { title: 'Last Name', name: 'last_name', sortField: 'last_name', link: '#/student/{id}' }, { title: 'Citizenship 1', name: 'citizenship1_cntry', sortField: 'nationality_cntry' }, { title: 'Street Address', name: 'address', sortField: 'address' }, { title: 'Postal Code', name: 'zip', sortField: 'zip' }, { title: 'City', name: 'city', sortField: 'city' }, { title: 'Country', name: 'cntry', sortField: 'cntry' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'Student Fee',
  overviewTitle: 'Student Fee',
  overviewRouterUrl: 'studentfees',
  getFilterName: function getFilterName(context) {
    return 'studentfees';
  },

  overviewApiUrl: '/studentfees/',
  detailTitle: 'Student Fee Detail',
  detailRouterUrl: 'studentfee',
  detailApiUrl: '/studentfees/',
  quickFilterName: 'Intake',
  quickFilterField: 'name',
  advancedSearch: true,
  updateNewRecord: function updateNewRecord(context, rec) {
    rec.registration_fee_amount = 0.0;
    rec.participationfee1_amount = 0.0;
    rec.participationfee2_amount = 0.0;
    rec.administrationfee1_amount = 0.0;
    rec.administrationfee2_amount = 0.0;
    rec.monthly_allowance_amount = 0.0;
  },
  getDefaultFilter: function getDefaultFilter(context) {
    return {};
  },

  sortOrder: [{
    field: 'intake',
    sortField: 'intake',
    direction: 'asc'
  }],
  fields: [{ title: 'Intake', name: 'intake', sortField: 'intake', link: '#/studentfee/{id}' }, { title: 'Scholarship', name: 'scholarship_code', sortField: 'scholarship_code' }, { title: 'Reg Fee', name: 'registration_fee_amount', sortField: 'registration_fee_amount' }, { title: 'Part Fee Y1', name: 'participationfee1_amount', sortField: 'participationfee1_amount' }, { title: 'Part Fee Y2', name: 'participationfee2_amount', sortField: 'participationfee2_amount' }, { title: 'Admin Fee Y1', name: 'administrationfee1_amount', sortField: 'administrationfee1_amount' }, { title: 'Admin Fee Y2', name: 'administrationfee2_amount', sortField: 'administrationfee2_amount' }, { title: 'Monthly Allowance', name: 'monthly_allowance_amount', sortField: 'monthly_allowance_amount' }, { title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'University',
  overviewTitle: 'Universities',
  overviewRouterUrl: 'universities',
  getFilterName: function getFilterName(context) {
    return 'universities';
  },

  overviewApiUrl: '/universities/',
  detailTitle: 'University Detail',
  detailRouterUrl: 'university',
  detailApiUrl: '/universities/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [{
    field: 'name',
    sortField: 'name',
    direction: 'asc'
  }],
  fields: [{ title: 'Name', name: 'name', sortField: 'name', link: '#/university/{id}' }, { title: 'Short Name', name: 'shortname', sortField: 'shortname' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteTitle: 'User',
  overviewTitle: 'Users',
  overviewRouterUrl: 'users',
  getFilterName: function getFilterName(context) {
    return 'users';
  },

  overviewApiUrl: '/users/',
  detailTitle: 'User Detail',
  detailRouterUrl: 'user',
  detailApiUrl: '/users/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: false,
  disableDelete: function disableDelete(rec) {
    return true;
  },

  sortOrder: [{
    field: 'usr_login_name',
    sortField: 'usr_login_name',
    direction: 'asc'
  }],
  fields: [{ title: 'Login', name: 'usr_login_name', sortField: 'usr_login_name', link: '#/user/{id}' }, { title: 'Name', name: 'usr_name', sortField: 'usr_name' }, { title: 'Role', name: 'userrole_name', sortField: 'userrole_name' }, { title: 'Active', name: 'usr_active', sortField: 'usr_active', callback: 'formatBoolean' }, { name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center' }]
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommonMixin__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OverviewLayout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OverviewLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OverviewLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailField__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation__ = __webpack_require__(61);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OverviewMixin',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__CommonMixin__["a" /* default */]],
  components: {
    OverviewLayout: __WEBPACK_IMPORTED_MODULE_2__OverviewLayout___default.a,
    DetailField: __WEBPACK_IMPORTED_MODULE_3__DetailField___default.a
  },
  data: function data() {
    return {
      searchRec: {},
      bulkRec: {},
      boolFilterOptions: [{ 'text': '', 'value': '' }, { 'text': 'yes', 'value': 'yes' }, { 'text': 'no', 'value': 'no' }]
    };
  },

  computed: {},
  methods: {
    doFilter: function doFilter() {
      this.$refs.overview.setFilter(this.searchRec);
    },
    exportSelection: function exportSelection(url, filename) {
      var filterParams = this.$refs.overview.getFilterParams(this.searchRec);
      this.api.downloadPost(url, filterParams, filename);
    },
    postWithSelection: function postWithSelection(url, errorMsg, successFnc) {
      var filterParams = this.$refs.overview.getFilterParams(this.searchRec);
      this.api.post(url, filterParams, function (data) {
        if (successFnc) successFnc();
      }, errorMsg, this.$refs.overview.$refs.alert);
    },
    hasSelections: function hasSelections() {
      return this.$refs.overview ? this.$refs.overview.table.selectedTo.length : 0;
    },
    bulkOk: function bulkOk(url) {
      var _this = this;

      var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'applying bulk edit';
      var successFnc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var selectedIds = this.$refs.overview.table.selectedTo;
      var changes = __WEBPACK_IMPORTED_MODULE_4__validation__["a" /* default */].getChangedFields(this.validator, this.bulkRec);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(changes).length === 0) return;
      var rec = { 'ids': selectedIds, 'changes': changes };
      this.api.post(url, rec, function (data) {
        if (successFnc) successFnc();
        _this.$refs.overview.table.selectedTo = [];
        _this.$refs.overview.refreshTable();
      }, errorMsg, this.$refs.overview.$refs.alert);
    }
  }
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommonMixin__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailLayout__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DetailLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailField__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailField__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DetailMixin',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__CommonMixin__["a" /* default */]],
  components: {
    DetailLayout: __WEBPACK_IMPORTED_MODULE_1__DetailLayout___default.a,
    DetailField: __WEBPACK_IMPORTED_MODULE_2__DetailField___default.a
  },
  computed: {
    isReadOnly: function isReadOnly() {
      return !this.isEdit && !this.isNew;
    },
    isEdit: function isEdit() {
      return this.$route.query.mode === 'edit';
    },
    isNew: function isNew() {
      return this.$route.params.id === 'new';
    }
  },
  data: function data() {
    return {
      dataValid: false
    };
  },

  methods: {
    setDataValid: function setDataValid() {
      this.dataValid = true;
    }
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Config__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Event_Overview__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Event_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Event_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_User_Overview__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_User_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_User_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_User_Detail__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_User_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_User_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Country_Overview__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Country_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Country_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Country_Detail__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Country_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Country_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_University_Overview__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_University_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_University_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_University_Detail__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_University_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_University_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Program_Overview__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Program_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Program_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Program_Detail__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Program_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Program_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_StudentFee_Overview__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_StudentFee_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_StudentFee_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_StudentFee_Detail__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_StudentFee_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_StudentFee_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Milestone_Overview__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Milestone_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Milestone_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Milestone_Detail__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Milestone_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Milestone_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Student_Overview__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Student_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Student_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Student_Detail__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Student_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_Student_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Contract_Overview__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Contract_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_Contract_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Contract_Detail__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Contract_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_Contract_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_InvoicePayment_Overview__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_InvoicePayment_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_InvoicePayment_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_InvoicePayment_Detail__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_InvoicePayment_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_InvoicePayment_Detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_ScholarshipPayment_Overview__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_ScholarshipPayment_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_ScholarshipPayment_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_ScholarshipPayment_Detail__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_ScholarshipPayment_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_ScholarshipPayment_Detail__);






























var privAdministrator = { auth: ['Developer', 'Administrator'] };

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a }, { path: '/login', name: 'login', meta: { auth: false }, component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a }, { path: '/config', name: 'config', meta: privAdministrator, component: __WEBPACK_IMPORTED_MODULE_4__views_Config___default.a }, { path: '/events', name: 'events', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_5__views_Event_Overview___default.a }, { path: '/users', name: 'users', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_6__views_User_Overview___default.a }, { path: '/user/:id', name: 'user', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_7__views_User_Detail___default.a }, { path: '/countries', name: 'countries', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_8__views_Country_Overview___default.a }, { path: '/country/:id', name: 'country', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_9__views_Country_Detail___default.a }, { path: '/universities', name: 'universities', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_10__views_University_Overview___default.a }, { path: '/university/:id', name: 'university', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_11__views_University_Detail___default.a }, { path: '/programs', name: 'programs', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_12__views_Program_Overview___default.a }, { path: '/program/:id', name: 'program', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_13__views_Program_Detail___default.a }, { path: '/studentfees', name: 'studentfees', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_14__views_StudentFee_Overview___default.a }, { path: '/studentfee/:id', name: 'studentfee', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_15__views_StudentFee_Detail___default.a }, { path: '/milestones', name: 'milestones', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_16__views_Milestone_Overview___default.a }, { path: '/milestone/:id', name: 'milestone', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_17__views_Milestone_Detail___default.a }, { path: '/students', name: 'students', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_18__views_Student_Overview___default.a }, { path: '/student/:id', name: 'student', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_19__views_Student_Detail___default.a }, { path: '/contracts', name: 'contracts', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_20__views_Contract_Overview___default.a }, { path: '/contract/:id', name: 'contract', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_21__views_Contract_Detail___default.a }, { path: '/invoices/planned', name: 'planned_invoices', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview___default.a }, { path: '/invoices/numbered', name: 'numbered_invoices', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview___default.a }, { path: '/invoices/creditnote', name: 'creditnote_invoices', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_22__views_Invoice_Overview___default.a }, { path: '/invoice/planned/:id', name: 'planned_invoice', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail___default.a }, { path: '/invoice/numbered/:id', name: 'numbered_invoice', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail___default.a }, { path: '/invoice/creditnote/:id', name: 'creditnote_invoice', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_23__views_Invoice_Detail___default.a }, { path: '/invoicepayments', name: 'invoicepayments', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_24__views_InvoicePayment_Overview___default.a }, { path: '/invoicepayment/:id', name: 'invoicepayment', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_25__views_InvoicePayment_Detail___default.a }, { path: '/scholarshippayments/planned', name: 'planned_scholarshippayments', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_26__views_ScholarshipPayment_Overview___default.a }, { path: '/scholarshippayments/numbered', name: 'numbered_scholarshippayments', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_26__views_ScholarshipPayment_Overview___default.a }, { path: '/scholarshippayment/planned/:id', name: 'planned_scholarshippayment', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_27__views_ScholarshipPayment_Detail___default.a }, { path: '/scholarshippayment/numbered/:id', name: 'numbered_scholarshippayment', meta: { auth: true }, component: __WEBPACK_IMPORTED_MODULE_27__views_ScholarshipPayment_Detail___default.a }]
}));

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    filterMap: {},
    activePageMap: {},
    choiceCache: {}
  },
  getters: {
    getFilterByName: function getFilterByName(state, getters) {
      return function (name) {
        if (name in state.filterMap) {
          return state.filterMap[name];
        }
      };
    },
    getActivePageByName: function getActivePageByName(state, getters) {
      return function (name) {
        if (name in state.activePageMap) return state.activePageMap[name];else return 1;
      };
    },
    getCachedChoice: function getCachedChoice(state, getters) {
      return function (name) {
        if (name in state.choiceCache) return state.choiceCache[name];
      };
    }
  },
  mutations: {
    setFilter: function setFilter(state, payload) {
      state.filterMap[payload.name] = payload.value;
    },
    setActivePage: function setActivePage(state, payload) {
      state.activePageMap[payload.name] = payload.value;
    },
    setCachedChoice: function setCachedChoice(state, payload) {
      state.choiceCache[payload.name] = payload.value;
    }
  }
});

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)
__webpack_require__(636)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);

__webpack_require__(634).polyfill();



var API_URL = 'api/v1.0';
function getApiUrl(url) {
  return API_URL + url;
}

function handleApiError(cmd, error, errorFnOrMsg, context) {
  console.log('Error in ' + cmd, error);
  if (error.response.status === 401 && context) {
    context.$auth.logout();
    location.replace('/');
  } else if (error.response.status === 409 && context) {
    context.reportApiError(error.response.data.message);
  } else if (typeof errorFnOrMsg === 'function') {
    errorFnOrMsg(error);
  } else if (typeof errorFnOrMsg === 'string') {
    context.reportApiError('Server error while ' + errorFnOrMsg);
  }
}
function _downloadFromResponse(response, filename) {
  var disposition = response.headers['content-disposition'];
  var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  var matches = filenameRegex.exec(disposition);

  if (matches != null && matches[1]) {
    filename = matches[1].replace(/['"]/g, '');
  }
  console.log(response.data.length, response.headers['content-type']);
  var blob = new Blob([response.data], { type: response.headers['content-type'] });
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = window.URL.createObjectURL(blob);
  console.log(a.href);
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(a.href);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  handleVueTableApiError: function handleVueTableApiError(tableName, error, context) {
    handleApiError('Table api.get', error, null, context);
  },
  getAPI_URL: function getAPI_URL(url) {
    return getApiUrl(url);
  },
  queryStringify: function queryStringify(url, obj) {
    return url + '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(obj);
  },
  get: function get(url, queryObj, successFn, errorFn, context) {
    url = getApiUrl(url);
    if (queryObj) {
      url += '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(queryObj);
    }
    console.log('api.get', url);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
      successFn(response.data);
    }).catch(function (error) {
      handleApiError('api.get', error, errorFn, context);
    });
  },
  putUpdate: function putUpdate(url, data, successFn, errMsg, alertHandler) {
    console.assert(alertHandler);
    console.assert(alertHandler.reportApiError);
    url = getApiUrl(url);
    console.log('api.put', url, data);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, data).then(function (response) {
      successFn(response.data);
    }).catch(function (error) {
      handleApiError('api.put', error, errMsg, alertHandler);
    });
  },
  post: function post(url, data, successFn, errMsg, alertHandler) {
    console.assert(alertHandler);
    console.assert(alertHandler.reportApiError);
    url = getApiUrl(url);
    console.log('api.post', url, data);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data).then(function (response) {
      successFn(response.data);
    }).catch(function (error) {
      handleApiError('api.post', error, errMsg, alertHandler);
    });
  },
  delete: function _delete(url, successFn, errMsg, alertHandler) {
    console.assert(alertHandler);
    console.assert(alertHandler.reportApiError);
    url = getApiUrl(url);
    console.log('api.delete', url);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url).then(function (response) {
      successFn(response.data);
    }).catch(function (error) {
      handleApiError('api.delete', error, errMsg, alertHandler);
    });
  },
  downloadPost: function downloadPost(url, data, filename) {
    url = getApiUrl(url);
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'post',
      url: url,
      data: data,
      responseType: 'arraybuffer'
    }).then(function (response) {
      _downloadFromResponse(response, filename);
    }).catch(function (error) {
      handleApiError('api.post', error, null, null);
    });
  },
  downloadFromResponse: function downloadFromResponse(response, filename) {
    return _downloadFromResponse(response, filename);
  },
  uploadPost: function uploadPost(url, files, onSuccess) {
    var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var onProgress = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    var onlySingle = true;
    var field = 'file';
    var state = {};
    url = getApiUrl(url);
    var fmData = new FormData();

    if (onlySingle) {
      fmData.append(field, files[0]);
    } else {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var x = _step.value;

          if (!isNaN(x)) {
            fmData.append(field, files[x]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    state.loading = 1;
    var axioscfg = {
      method: 'POST',
      url: url,
      data: fmData,
      onUploadProgress: function onUploadProgress(event) {
        if (event.lengthComputable) {
          state.progress = 100 * Math.round(event.loaded) / event.total;

          if (typeof onProgress === 'function' && onProgress) {
            onProgress(state);
          }
        }
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_axios___default()(axioscfg).then(function (response) {
      state.loading = 2;

      if (typeof onSuccess === 'function' && onSuccess) {
        onSuccess(response, state);
      }
    }).catch(function (error) {
      state.loading = 3;
      state.hasError = true;
      console.log('Upload ERROR', error);
      if (typeof onError === 'function' && onError) {
        onError(error, state);
      }
    });
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped table-bordered',
    ascendingIcon: 'fa fa-chevron-up',
    descendingIcon: 'fa fa-chevron-down',
    handleIcon: 'fa fa-menu-hamburger',
    renderIcon: function renderIcon(classes, options) {
      return '<span class=\'' + classes.join(' ') + '\'></span>';
    }
  },
  paginationInfo: {
    infoClass: 'pull-left'
  },
  pagination: {
    wrapperClass: 'pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border',
    linkClass: 'btn btn-border',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: ''
    }
  }
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_store__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);














__webpack_require__(330);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth___default.a, {
  auth: __webpack_require__(322),
  http: __webpack_require__(323),
  router: __webpack_require__(324),
  rolesVar: 'userrole_name'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_9__vuex_store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate___default.a, { errorBagName: 'veeErrors', fieldsBagName: 'veeFields', inject: false });

var alwaysOk = function alwaysOk(value) {
  return true;
};

__WEBPACK_IMPORTED_MODULE_6_vee_validate__["Validator"].extend('ok', {
  validate: alwaysOk,
  getMessage: function getMessage() {
    return 'ok';
  }
});


new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App___default.a }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disableNew: true,
  deleteTitle: 'Log Event',
  overviewTitle: 'Log Events',
  overviewRouterUrl: 'events',
  getFilterName: function getFilterName(context) {
    return 'events';
  },

  overviewApiUrl: '/logging/',
  detailTitle: 'Log Event Detail',
  detailRouterUrl: 'event',
  detailApiUrl: '/logging/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: true,
  sortOrder: [{
    field: 'le_time',
    sortField: 'le_time',
    direction: 'desc'
  }],
  fields: [{ title: 'Time', name: 'le_time', sortField: 'le_time', callback: 'formatTimeStamp' }, { title: 'Event Type', name: 'eventtype', sortField: 'eventtype' }, { title: 'Message', name: 'le_message', sortField: 'le_message' }, { title: 'Student', name: 'student_name', sortField: 'student_name' }, { title: 'Contract', name: 'le_contract', sortField: 'le_contract' }, { title: 'User', name: 'usr_name', sortField: 'student_name' }]
});

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        label: {
            default: 'Loading...'
        },
        show: {
            default: false
        },
        overlay: {
            default: true
        },
        loaderClass: {
            default: 'loader-wrapper'
        },
        overlayClass: {
            default: 'white-overlay'
        },

        eventBus: {
            default: null
        },
        eventShow: {
            default: 'show-full-loading'
        },
        eventHide: {
            default: 'hide-full-loading'
        }
    },
    data: function data() {
        return {
            showing: false
        };
    },

    watch: {
        show: function show(val) {
            this.showing = val;
        }
    },
    methods: {
        showMe: function showMe() {
            this.showing = true;
        },
        hideMe: function hideMe() {
            this.showing = false;
        },
        registerBusMethods: function registerBusMethods() {
            this.eventBus.$on(this.eventShow, this.showMe);
            this.eventBus.$on(this.eventHide, this.hideMe);
        }
    },
    mounted: function mounted() {
        if (this.eventBus) this.registerBusMethods();
    }
});

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    perPage: {
      type: Number,
      default: function _default() {
        return 10;
      }
    },
    initialPage: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: []
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
  },

  computed: {
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    }
  },
  methods: {
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible,
            link: field.link === undefined ? '' : field.link
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      this.apiMode = false;
      if (Array.isArray(data)) {
        this.tableData = data;
        return;
      }

      this.fireEvent('loading');

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    renderTitle: function renderTitle(field) {
      var title = typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;

      if (title.length > 0 && this.isInCurrentSortGroup(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        return title + ' ' + this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"');
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAllQueryParams();

      _axios2.default[this.httpMethod](this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};
      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] == 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }

      return result;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      this.loadData();
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortIcon: function sortIcon(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    applyLink: function applyLink(value, item, field) {
      if (field.link && field.link.length) {
        var expr = /\{(.+)\}/;
        var linkField = expr.exec(field.link)[1];
        var link = field.link.replace('{' + linkField + '}', item[linkField]);
        var result = '<a href="' + link + '">' + value + '</a>';
        return result;
      } else return value;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        console.log('data mode: array');
        this.setData(this.data);
      } else {
        this.normalizeSortOrder();
        this.setData(this.dataManager(this.sortOrder, this.makePagination()));
      }
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    }
  }
};

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertHandler',
  data: function data() {
    return {
      alertInfo: '',
      alertVariant: 'info',
      alertShow: false
    };
  },

  methods: {
    reset: function reset() {
      this.alertInfo = '';
      this.alertVariant = 'success';
    },
    dismissMessage: function dismissMessage() {
      this.reset();
      this.alertShow = false;
    },
    appendMessage: function appendMessage(msg) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.alertInfo += msg;
      if (isError) this.alertVariant = 'success';
      this.alertShow = true;
    },
    reportApiError: function reportApiError(errMsg) {
      this.alertInfo = errMsg;
      this.alertVariant = 'danger';
      this.alertShow = true;
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivilegeMixin__ = __webpack_require__(60);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BarTop',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__PrivilegeMixin__["a" /* default */]],

  computed: {
    userInfo: function userInfo() {
      return this.$auth.user().usr_name + ' [' + this.$auth.user().userrole_name + ']';
    },
    versionInfo: function versionInfo() {
      return "v2.0.7";
    }
  },
  methods: {}
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DateRange',
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  props: {
    value: { default: null }
  },
  data: function data() {
    return {
      start: null,
      end: null
    };
  },

  watch: {
    value: function value(v) {
      console.log('DateRange.watch.value', this.value, v);
      if (v === null) {
        this.start = this.end = null;
      }
    }
  },
  methods: {
    onInput: function onInput() {
      var result = '';
      if (this.start) result += __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start).format('YYYY-MM-DD');
      result += '|';
      if (this.end) result += __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end).format('YYYY-MM-DD');
      this.$emit('input', result);
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateRange__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DateRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatting__ = __webpack_require__(139);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DetailField',
  inject: ['$validator'],
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a, Daterange: __WEBPACK_IMPORTED_MODULE_5__DateRange___default.a, Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a },
  props: {
    label: { type: String, required: true },
    field: { type: String, required: true },
    field2: { type: String, default: '' },
    static: { type: Boolean, default: false },
    hasNull: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    labelCols: { type: Number, default: 3 },
    type: { type: String, default: 'text' },
    vvalidate: { type: String, required: true },
    validator: { type: Object, required: true },
    optionList: { type: Array, default: null },
    optionListApiUrl: { type: String, default: null },
    optionListApiParams: { type: Object, default: null },
    optionListApiDoUpdate: { type: Boolean, default: true },
    rec: { type: Object, required: true }
  },
  data: function data() {
    console.assert(this.vvalidate, 'vvalidate should not be empty for ' + this.field);

    if (!(this.field in this.rec)) {
      this.$set(this.rec, this.field, '');
    }
    if (!this.static) __WEBPACK_IMPORTED_MODULE_2__validation__["a" /* default */].addValidation(this.validator, this.rec, this.field, this.label, this.vvalidate);
    return {
      finalOptionList: [],
      finalApiParams: this.optionListApiParams,
      finalApiUpdate: this.optionListApiDoUpdate,
      booleanOptionList: [{ 'text': 'Yes', 'value': true }, { 'text': 'No', 'value': false }]
    };
  },
  created: function created() {
    this.updateOptions();
  },

  computed: {
    veeState: function veeState() {
      return this.validator.errors.has(this.field) ? 'invalid' : '';
    },
    veeFeedBack: function veeFeedBack() {
      return this.validator.errors.first(this.field);
    },
    hasClearButton: function hasClearButton() {
      return this.vvalidate !== 'required';
    }
  },
  methods: {
    onInput: function onInput(value, isEnterEvent) {
      __WEBPACK_IMPORTED_MODULE_2__validation__["a" /* default */].validateValue(this.validator, this.field, value);
      this.$emit('input', value);
      if (isEnterEvent) this.$emit('enter', value);
    },
    onEnter: function onEnter(theEvent) {
      this.$emit('enter', theEvent);
    },
    getStaticValue: function getStaticValue() {
      var thisValue = this.rec[this.field];

      if (this.finalOptionList.length || this.optionListApiUrl) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.finalOptionList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var option = _step.value;

            if (option.value === thisValue) {
              return option.text;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var otherField = this.field.substring(0, this.field.length - 3);
        if (this.rec[otherField]) return this.rec[otherField];
        return '';
      } else if (this.type === 'text') return thisValue;else if (this.type === 'phone') return thisValue;else if (this.type === 'datetime') return __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatDateTime(thisValue);else if (this.type === 'date') return __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatDate(thisValue);else if (this.type === 'simpledate') return __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatDate(thisValue);else if (this.type === 'timestamp_user') return thisValue ? __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatTimeStamp(thisValue) + ' by ' + this.rec[this.field2] : '';else if (this.type === 'textarea') return thisValue ? thisValue.replace(/\n/g, '<br />') : '';else if (this.type === 'email') return '<a href="mailto:' + thisValue + '">' + thisValue + '</a>';else if (this.type === 'boolean') return __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatBoolean(thisValue);else if (this.type === 'password') return thisValue ? '***' : '';else if (this.type === 'money') return __WEBPACK_IMPORTED_MODULE_6__formatting__["a" /* default */].formatMoney(thisValue);else {
        console.log('getStaticValue not implemented for ' + this.type);
        return thisValue;
      }
    },
    updateOptionsParams: function updateOptionsParams(params) {
      this.finalApiParams = params;
      this.finalApiUpdate = true;
      this.updateOptions();
    },
    _setOptions: function _setOptions(options) {
      this.finalOptionList = options;
      var v = this.rec[this.field];
      this.rec[this.field] = null;
      this.rec[this.field] = v;
    },
    _callAPIChoice: function _callAPIChoice(urlChoiceBase, checksum) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get(this.optionListApiUrl, this.finalApiParams, function (data) {
        var options = data.records.map(function (r) {
          return { 'text': r.name, 'value': r.id };
        });
        _this._setOptions(options);

        if (urlChoiceBase) {
          var newCache = { 'options': options, 'checksum': checksum };
          _this.$store.commit({ type: 'setCachedChoice', name: urlChoiceBase, value: newCache });
        }
      }, function (error) {
        console.log(error);
      }, this);
    },
    _callAPIOptionList: function _callAPIOptionList() {
      var _this2 = this;

      console.assert(this.optionListApiUrl.endsWith('choice/'));
      var useChecksumCache = 1;
      if (useChecksumCache && !this.finalApiParams) {
        var urlChoiceBase = this.optionListApiUrl.substring(0, this.optionListApiUrl.length - 7);
        var urlChoiceChecksum = urlChoiceBase + 'choice_checksum/';
        var cachedChoice = this.$store.getters.getCachedChoice(urlChoiceBase);

        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get(urlChoiceChecksum, null, function (data) {
          var checksum = data.checksum;
          if (cachedChoice && cachedChoice.checksum === checksum) {
            console.log('CacheHit', urlChoiceBase, checksum);
            _this2._setOptions(cachedChoice.options);
          } else {
            _this2._callAPIChoice(urlChoiceBase, checksum);
          }
        }, function (error) {
          console.log(error);
          _this2._callAPIChoice(null, null);
        }, this);
      } else {
        this._callAPIChoice(null, null);
      }
    },
    updateOptions: function updateOptions() {
      if (this.optionList) {
        if (typeof this.optionList[0] === 'string') {
          this.finalOptionList = this.optionList.map(function (s) {
            return { 'text': s, 'value': s };
          });
        } else this.finalOptionList = this.optionList;
      } else if (this.optionListApiUrl && this.finalApiUpdate) {
        this._callAPIOptionList();
      }
    }
  }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivilegeMixin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarTop_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarTop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BarTop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlertHandler_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlertHandler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AlertHandler_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation__ = __webpack_require__(61);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { barTop: __WEBPACK_IMPORTED_MODULE_2__BarTop_vue___default.a, alertHandler: __WEBPACK_IMPORTED_MODULE_3__AlertHandler_vue___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__PrivilegeMixin__["a" /* default */]],
  props: {
    tableCfg: { type: Object, required: true }
  },
  data: function data() {
    return {
      rec: {},
      queryInprogress: false
    };
  },

  computed: {
    isReadOnly: function isReadOnly() {
      return !this.isEdit && !this.isNew;
    },
    isEdit: function isEdit() {
      return this.$route.query.mode === 'edit';
    },
    isNew: function isNew() {
      return this.$route.params.id === 'new';
    },
    isSaveDisabled: function isSaveDisabled() {
      return this.queryInprogress;
    },
    detailTitle: function detailTitle() {
      return this.getTblCfg('detailTitle');
    },
    detailRouterUrl: function detailRouterUrl() {
      return this.getTblCfg('detailRouterUrl');
    },
    overviewRouterUrl: function overviewRouterUrl() {
      return this.getTblCfg('overviewRouterUrl');
    },
    deleteTitle: function deleteTitle() {
      return this.getTblCfg('deleteTitle');
    }
  },
  mounted: function mounted() {
    this.getRecord();
  },

  methods: {
    getTblCfg: function getTblCfg(key) {
      if (typeof this.tableCfg[key] === 'function') return this.tableCfg[key](this);else return this.tableCfg[key];
    },
    backToOverview: function backToOverview() {
      this.$router.push({ name: this.overviewRouterUrl });
    },
    getRecord: function getRecord() {
      var _this = this;

      if (this.isNew) {
        __WEBPACK_IMPORTED_MODULE_5__validation__["a" /* default */].setOriginalRec(this.$parent.validator, {});
        if (this.tableCfg.updateNewRecord) this.tableCfg.updateNewRecord(this, this.rec);
        this.$parent.setDataValid();
      } else {
        var id = this.$route.params.id;

        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(this.tableCfg.detailApiUrl + id, null, function (data) {
          _this.rec = data;

          if (!_this.readOnly) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
              return _this.validateForm(null);
            });
          }
          __WEBPACK_IMPORTED_MODULE_5__validation__["a" /* default */].setOriginalRec(_this.$parent.validator, data);
          _this.$parent.setDataValid();
        }, function (error) {
          console.log(error);
        }, this);
      }
    },
    validateForm: function validateForm(okFnc, failFnc) {
      __WEBPACK_IMPORTED_MODULE_5__validation__["a" /* default */].validateAll(this.$parent.validator, this.rec, okFnc, failFnc);
    },
    submitRecord: function submitRecord() {
      this.validateForm(this.commitRecord);
    },
    commitRecord: function commitRecord(rec) {
      var _this2 = this;

      this.queryInprogress = true;
      if (this.isNew) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post(this.tableCfg.detailApiUrl, rec, function (data) {
          _this2.queryInprogress = false;
          _this2.$router.push({ name: _this2.detailRouterUrl, params: { id: data.id } });
        }, 'saving new ' + this.detailTitle, this.$refs.alert);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].putUpdate(this.tableCfg.detailApiUrl + rec.id, rec, function (data) {
          _this2.queryInprogress = false;
          _this2.$router.push({ name: _this2.detailRouterUrl, params: { id: rec.id } });
        }, 'saving update', this.$refs.alert);
      }
    },
    deleteRecord: function deleteRecord() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete(this.tableCfg.detailApiUrl + this.rec.id, function (data) {
        _this3.backToOverview();
      }, 'deleting ' + this.detailTitle, this.$refs.alert);
    }
  }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivilegeMixin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BarTop_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BarTop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BarTop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AlertHandler_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AlertHandler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AlertHandler_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VuetableCssConfig_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__formatting__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('vuetable', __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default.a);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    barTop: __WEBPACK_IMPORTED_MODULE_5__BarTop_vue___default.a,
    alertHandler: __WEBPACK_IMPORTED_MODULE_6__components_AlertHandler_vue___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__PrivilegeMixin__["a" /* default */]],
  props: {
    tableCfg: { type: Object, required: true }
  },
  data: function data() {
    var searchRec = this.$parent.searchRec;
    var advancedFilter = true;
    var storedFilterName = this.tableCfg.getFilterName(this);
    var defaultFilterRec = this.tableCfg.getDefaultFilter !== undefined ? this.tableCfg.getDefaultFilter(this) : {};
    var storedFilterRec = this.$store.getters.getFilterByName(storedFilterName);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(defaultFilterRec).forEach(function (key) {
      this.$set(searchRec, key, defaultFilterRec[key]);
    }, this);
    if (storedFilterRec) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(storedFilterRec).forEach(function (key) {
        if (storedFilterRec[key]) {
          if (storedFilterRec[key] !== defaultFilterRec[key]) advancedFilter = true;
          this.$set(searchRec, key, storedFilterRec[key]);
        }
      }, this);
    }

    var fixedParams = {};
    var appendParams = {};
    if (this.tableCfg.updateFilter) {
      this.tableCfg.updateFilter(this, fixedParams);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(appendParams, fixedParams);
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(appendParams, searchRec);

    return {
      searchRec: searchRec,
      defaultFilterRec: defaultFilterRec,
      storedFilterName: storedFilterName,
      advancedFilter: advancedFilter,
      appendParams: appendParams,
      fixedParams: fixedParams,
      paginationData: null,
      apiUrl: __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getAPI_URL(this.tableCfg.overviewApiUrl),
      css: __WEBPACK_IMPORTED_MODULE_7__VuetableCssConfig_js__["a" /* default */],
      batchMode: false,
      batchCounter: 0,
      batchMax: 100
    };
  },

  computed: {
    overviewTitle: function overviewTitle() {
      return this.getTblCfg('overviewTitle');
    },
    fields: function fields() {
      return this.getTblCfg('fields');
    },
    detailRouterUrl: function detailRouterUrl() {
      return this.getTblCfg('detailRouterUrl');
    },
    disableNew: function disableNew() {
      return this.getTblCfg('disableNew') || !this.privUser;
    },
    table: function table() {
      return this.$refs.vuetable;
    },
    alert: function alert() {
      return this.$refs.alert;
    }
  },
  methods: {
    getTblCfg: function getTblCfg(key) {
      if (typeof this.tableCfg[key] === 'function') return this.tableCfg[key](this);else return this.tableCfg[key];
    },
    refreshTable: function refreshTable() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        return _this.table.refresh();
      });
    },

    quickFilterChanged: __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function (e) {
      this.doQuickFilter();
    }, 500),
    doQuickFilter: function doQuickFilter() {
      var params = {};
      params[this.tableCfg.quickFilterField] = this.searchRec[this.tableCfg.quickFilterField];
      this.setFilter(params);
    },
    resetFilter: function resetFilter() {
      this.setFilter({});
      if (this.tableCfg.advancedSearch) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.searchRec).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.searchRec, key, null);
        }, this);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.defaultFilterRec).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.searchRec, key, this.defaultFilterRec[key]);
        }, this);
      }
    },
    setFilter: function setFilter(params) {
      this.$store.commit({ type: 'setFilter', name: this.storedFilterName, value: params });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.appendParams).forEach(function (key) {
        delete this.appendParams[key];
      }, this);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.appendParams, params);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fixedParams).length) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.appendParams, this.fixedParams);
      this.refreshTable();
    },
    getFilterParams: function getFilterParams(advancedParams) {
      var result = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, advancedParams);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fixedParams).length) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, this.fixedParams);
      return result;
    },
    gotoNewDetail: function gotoNewDetail() {
      var route = { name: this.detailRouterUrl, params: { id: 'new' } };
      if (this.tableCfg.updateNewRoute) {
        this.tableCfg.updateNewRoute(this, route);
      }
      this.$router.push(route);
    },
    onPaginationData: function onPaginationData(data) {
      this.paginationData = data;
      this.$store.commit({ type: 'setActivePage', name: this.storedFilterName, value: data.current_page });
    },
    findInitialPage: function findInitialPage() {
      var activePage = this.$store.getters.getActivePageByName(this.storedFilterName);

      return activePage;
    },
    onLoadError: function onLoadError(response) {
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].handleVueTableApiError(this.overviewTitle, response, this);
    },
    formatBoolean: function formatBoolean(value) {
      return __WEBPACK_IMPORTED_MODULE_9__formatting__["a" /* default */].formatBoolean(value);
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_9__formatting__["a" /* default */].formatDate(value);
    },
    formatTimeStamp: function formatTimeStamp(value) {
      return __WEBPACK_IMPORTED_MODULE_9__formatting__["a" /* default */].formatTimeStamp(value);
    },
    formatMoney: function formatMoney(value) {
      return __WEBPACK_IMPORTED_MODULE_9__formatting__["a" /* default */].formatMoney(value);
    },
    getLabelForId: function getLabelForId(id, labelKey) {
      var tableData = this.table.tableData;
      for (var i in tableData) {
        var rec = tableData[i];
        if (rec.id === id) {
          return rec[labelKey];
        }
      }
      return 'id=' + id;
    },
    runNextBatch: function runNextBatch(index, processFnc, labelKey) {
      this.batchCounter = index + 1;
      if (index + 1 < this.batchMax) {
        this.nextBatch(index + 1, processFnc, labelKey);
      } else {
        this.batchMode = false;
        this.alert.appendMessage('Finished<br/>');
        this.table.selectedTo = [];
        this.refreshTable();
      }
    },
    nextBatch: function nextBatch(index, processFnc, labelKey) {
      var _this2 = this;

      var selectedIds = this.table.selectedTo;

      processFnc(selectedIds[index], function (data) {
        _this2.runNextBatch(index, processFnc, labelKey);
      }, function (error) {
        console.log('Error in batch callback', error);
        var id = selectedIds[index];
        var label = _this2.getLabelForId(id, labelKey);
        _this2.alert.appendMessage('Error for ' + label + '<br/>', true);
        _this2.runNextBatch(index, processFnc, labelKey);
      });
    },
    runBatch: function runBatch(processFnc, labelKey) {
      var selectedIds = this.table.selectedTo;

      this.alert.reset();
      this.batchMode = true;
      this.batchCounter = 0;
      this.batchMax = selectedIds.length;
      this.nextBatch(0, processFnc, labelKey);
    }
  }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BarTop_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BarTop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_BarTop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertHandler_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertHandler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AlertHandler_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DetailField__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DetailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DetailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PrivilegeMixin__ = __webpack_require__(60);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { barTop: __WEBPACK_IMPORTED_MODULE_2__components_BarTop_vue___default.a, alertHandler: __WEBPACK_IMPORTED_MODULE_3__components_AlertHandler_vue___default.a, DetailField: __WEBPACK_IMPORTED_MODULE_4__components_DetailField___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_PrivilegeMixin__["a" /* default */]],
  data: function data() {
    return {
      email_validator: __WEBPACK_IMPORTED_MODULE_1__validation__["a" /* default */].createValidator(),
      config: {},
      editEmail: false,
      files: {},
      tabIndex: 0,
      serverVersion: ''
    };
  },
  mounted: function mounted() {
    this.getConfig();
    this.getVersion();
  },

  methods: {
    getConfig: function getConfig() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('/config', null, function (data) {
        _this.config = data;
        __WEBPACK_IMPORTED_MODULE_1__validation__["a" /* default */].setOriginalRec(_this.email_validator, data.email_config);
      }, 'getting configuration', this.$refs.alert);
    },
    getVersion: function getVersion() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('/config/version', null, function (data) {
        _this2.serverVersion = data.version;
      }, 'getting configuration', this.$refs.alert);
    },
    downloadTemplate: function downloadTemplate(templ, index) {
      console.log('download()', templ);
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadPost('/config/get_template', templ, templ.filename);
    },
    uploadTemplate: function uploadTemplate(templ, index) {
      var _this3 = this;

      console.log(this.$refs.fileinput[index]);
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadPost(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].queryStringify('/config/import/', { internalname: templ.internalname }), [this.files[index]], function () {
        _this3.$refs.fileinput[index].reset();
      });
    },
    saveEmail: function saveEmail() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__validation__["a" /* default */].validateAll(this.email_validator, this.config.email_config, function (rec) {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].putUpdate('/config/email/', rec, function () {
          _this4.editEmail = false;
        }, 'saving configuration', _this4.$refs.alert);
        _this4.getConfig();
      });
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(35);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contract_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */],
      tabIndex: 0,
      fileRec: { ft_id: 1, description: '' },
      documentToUpload: '',
      activeDocument: null,
      activeRec: null,
      downloadPaymentRec: {}
    };
  },

  methods: {
    downloadPaymentStatus: function downloadPaymentStatus(rec) {
      console.log(rec);
      if (this.downloadPaymentRec) {
        this.api.downloadPost('/contracts/' + rec.id + '/download_pf_paymentstatus', this.downloadPaymentRec, 'Participation_Fee_Status.pdf');
      }
    },
    changeState: function changeState(rec, contractStatusId) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].putUpdate('/contracts/' + rec.id + '/update_status', { contract_status_id: contractStatusId }, function (data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rec, data);
      }, 'updating state', this.$refs.layout.$refs.alert);
    },
    downloadDocument: function downloadDocument(doc) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadPost('/contract_files/' + doc.id + '/download', {}, doc.filename);
    },
    uploadDocument: function uploadDocument(contractId, documentToUpload) {
      var _this = this;

      var rec = { contract_id: contractId, ft_id: this.fileRec.ft_id, description: this.fileRec.description, filename: documentToUpload.name };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/contract_files/', rec, function (cfData) {
        console.log('post result ', cfData);
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadPost('/contract_files/' + cfData.id + '/upload', [documentToUpload], function () {
          _this.$refs.fileinput.setFiles(null);
          _this.fileRec.description = '';
          _this.$refs.layout.getRecord();
        }, 'uploading document', _this.$refs.layout.$refs.alert);
      }, 'uploading document', this.$refs.layout.$refs.alert);
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].delete('/contract_files/' + this.activeDocument.id, function (data) {
        _this2.$refs.layout.getRecord();
      }, 'deleting document', this.$refs.layout.$refs.alert);
    },
    checkSwitchToSemesterPayment: function checkSwitchToSemesterPayment(rec) {
      this.activeRec = rec;
      this.$refs.modalSwitchSemesterPaymentOk.show();
    },
    doSwitchToSemesterPayment: function doSwitchToSemesterPayment() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/contracts/' + this.activeRec.id + '/switch_to_semester_payment', {}, function (data) {
        _this3.$refs.layout.$refs.alert.appendMessage(data.message + '<br/>');
      }, 'switch to semester payment', this.$refs.layout.$refs.alert);
    },
    requestPaymentInfo: function requestPaymentInfo(rec) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/contracts/' + rec.id + '/send_email_paymentinfo', {}, function (data) {}, 'requesting payment info', this.$refs.layout.$refs.alert);
    },
    downloadInvoiceDetails: function downloadInvoiceDetails(rec) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadPost('/contracts/' + rec.id + '/download_invoice_details', {}, function (data) {}, 'downloading invoice details', this.$refs.layout.$refs.alert);
    },
    onStartDateInput: function onStartDateInput(rec, startDate) {
      rec.end_date = new Date(startDate.getFullYear() + 2, startDate.getMonth(), startDate.getDate());
      rec.end_date = new Date(rec.end_date - 1);
    }
  }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contract_overview',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */],
      showProcessing: false,
      documentToUpload: null,
      exportPaymentRec: {},
      importDreamApplyRec: { academic_year: 2021, updates_in_last_days: 0 }
    };
  },

  methods: {
    exportPaymentStatus: function exportPaymentStatus() {
      if (this.exportPaymentRec) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.exportPaymentRec, this.searchRec);
        console.log(this.exportPaymentRec);
        this.api.downloadPost('/contracts/download_paymentstatus', this.exportPaymentRec, 'Balance_to_date.xlsx');
      }
    },
    importDreamApply: function importDreamApply() {
      var _this = this;

      if (this.importDreamApplyRec) {
        this.showProcessing = true;
        this.api.post('/contracts/import_dream_apply', this.importDreamApplyRec, function (data) {
          _this.showProcessing = false;
        }, function (error) {
          console.log('Error: ', error);_this.showProcessing = false;
        }, this.$refs.overview.alert);
      }
    },
    uploadExcel: function uploadExcel() {
      var _this2 = this;

      if (this.documentToUpload) {
        this.showProcessing = true;
        this.api.uploadPost('/contracts/import', [this.documentToUpload], function (response, state) {
          _this2.showProcessing = false;
          _this2.api.downloadPost('/contracts/get_import_results', { filename: response.data.filename, type: 'contracts' }, 'result.xlsx');
        }, 'uploading document', this.$refs.alert);
      }
    },
    uploadBankInfo: function uploadBankInfo() {
      var _this3 = this;

      if (this.documentToUpload) {
        this.showProcessing = true;
        this.api.uploadPost('/contracts/import_bankinfo', [this.documentToUpload], function (response, state) {
          _this3.showProcessing = false;
          _this3.api.downloadPost('/contracts/get_import_results', { filename: response.data.filename, type: 'bankinfo' }, 'result.xlsx');
        }, 'uploading document', this.$refs.alert);
      }
    },
    sendBankInfoRequest: function sendBankInfoRequest(id, okFnc, errorFnc) {
      this.api.post('/contracts/' + id + '/send_bankinfo_request', {}, okFnc, errorFnc, this.$refs.overview.alert);
    },
    sendPFStatus: function sendPFStatus(id, okFnc, errorFnc) {
      this.api.post('/contracts/' + id + '/send_pf_status', {}, okFnc, errorFnc, this.$refs.overview.alert);
    }
  }
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(141);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'country_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(141);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'country_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    OverviewLayout: __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(357);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BarTop_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BarTop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BarTop_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    barTop: __WEBPACK_IMPORTED_MODULE_0__components_BarTop_vue___default.a
  },
  mounted: function mounted() {
    if (!this.$auth.check()) {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldDefs_js__ = __webpack_require__(142);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_3__FieldDefs_js__["a" /* default */],
      cnRec: { amount: 0, description: '' },
      lrfRec: {}
    };
  },

  computed: {
    isPlanned: function isPlanned() {
      return this.tableCfg.subType(this) === 'planned';
    },
    isNumbered: function isNumbered() {
      return this.tableCfg.subType(this) === 'numbered';
    },
    isCreditNote: function isCreditNote() {
      return this.tableCfg.subType(this) === 'creditnote';
    }
  },
  methods: {
    isLocked: function isLocked() {
      return this.$refs.layout && this.$refs.layout.rec && this.$refs.layout.rec.is_locked;
    },
    createPDF: function createPDF(rec) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post('/invoices/' + rec.id + '/create_pdf', {}, function (data) {}, 'creating pdf', this.$refs.layout.$refs.alert);
    },
    downloadPDF: function downloadPDF(rec) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].downloadPost('/invoices/' + rec.id + '/download_pdf', {}, rec.pdf_filename);
    },
    getCancelCommand: function getCancelCommand(rec) {
      var cmd = 'Create Credit Note';
      if (rec.document_type_id !== 1 && rec.pro_forma) {
        cmd = 'Cancel Registration';
      }
      return cmd;
    },
    sendEmail: function sendEmail(rec, reminder) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post('/invoices/' + rec.id + '/send_email', { reminder: reminder }, function (data) {}, 'sending email', this.$refs.layout.$refs.alert);
    },
    createCreditNote: function createCreditNote(rec) {
      this.cnRec.linked_invoice_id = rec.linked_invoice_id;
      this.cnRec.cn_invoice_id = rec.id;
      this.cnRec.amount = rec.amount;
      this.cnRec.description = rec.description;
      this.cnRec.contract_id = rec.contract_id;
      this.cnRec.year = rec.year;
      this.cnRec.semester = rec.semester;
      this.cnRec.number = 'CN-' + rec.number;
      if (rec.document_type_id === 1) {
        this.cnRec.document_type_id = 2;
      }
      if (rec.document_type_id === 5) {
        this.cnRec.document_type_id = 6;
      }
      if (rec.document_type_id === 7) {
        this.cnRec.document_type_id = 8;
      }
      if (rec.document_type_id === 9) {
        this.cnRec.document_type_id = 10;
      }
      this.$refs.modalCreditNote.show();
    },
    okCreditNote: function okCreditNote() {
      var _this = this;

      var rec = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rec, this.cnRec);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post(this.tableCfg.detailApiUrl, rec, function (data) {
        _this.$router.push({ name: 'creditnote_invoice', params: { id: data.id } });
      }, 'creating credit note', this.$refs.layout.$refs.alert);
    },
    linkRegistrationFee: function linkRegistrationFee(rec) {
      this.lrfRec['invoice_id'] = rec.id;
      this.$refs.lfrOptionList.updateOptionsParams({ 'contract_id': rec.contract_id, 'document_type_id': 3 });
      this.$refs.modalLinkRegistrationFee.show();
    },
    okLinkRegistrationFee: function okLinkRegistrationFee() {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post('/invoices/' + this.lrfRec.invoice_id + '/link_registration_id', { 'registration_fee_id': this.lrfRec.registration_id }, function (data) {}, 'linking registration fee', this.$refs.layout.$refs.alert);
    }
  }
});

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(142);





function sleep(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  },

  computed: {
    isNumbered: function isNumbered() {
      return this.tableCfg.subType(this) === 'numbered';
    },
    isPlanned: function isPlanned() {
      return this.tableCfg.subType(this) === 'planned';
    },
    isCreditNote: function isCreditNote() {
      return this.tableCfg.subType(this) === 'creditnote';
    }
  },
  methods: {
    payMoney: function payMoney(props) {
      console.log(props.rowData.id);
    },
    simpleSleep: function simpleSleep(id, okFnc, errorFnc) {
      sleep(100).then(function () {
        okFnc('ok');
      });
    },
    createPDF: function createPDF(id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/create_pdf', {}, okFnc, errorFnc, this.$refs.overview.alert);
    },
    sendEmail: function sendEmail(id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/send_email', { reminder: false }, okFnc, errorFnc, this.$refs.overview.alert);
    },
    sendEmailReminder: function sendEmailReminder(id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/send_email', { reminder: true }, okFnc, errorFnc, this.$refs.overview.alert);
    }
  }
});

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(143);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {
    onCalcNetAmount: function onCalcNetAmount(rec) {
      rec.net_amount = Number(rec.amount_paid) - Number(rec.commission);
    },
    createPDF: function createPDF(rec) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post('/invoice_payments/' + rec.id + '/create_pdf', {}, function (data) {}, 'creating pdf', this.$refs.layout.$refs.alert);
    },
    downloadPDF: function downloadPDF(rec) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadPost('/invoice_payments/' + rec.id + '/download_pdf', {}, rec.pdf_filename);
    },
    sendEmail: function sendEmail(rec) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post('/invoice_payments/' + rec.id + '/send_email', {}, function (data) {
        _this.$refs.layout.$refs.alert.appendMessage('Email sent' + '<br/>');
      }, 'sending email', this.$refs.layout.$refs.alert);
    }
  }
});

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(143);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {
    sendEmail: function sendEmail(id, okFnc, errorFnc) {
      this.api.post('/invoice_payments/' + id + '/send_email', {}, okFnc, errorFnc, this.$refs.overview.alert);
    }
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      context: 'login context',
      e1: true,
      data: {
        username: '',
        password: ''
      }
    };
  },

  computed: {
    loginEnable: function loginEnable() {
      return !this.data.username || !this.data.password;
    }
  },
  methods: {
    login: function login() {
      this.$auth.login({
        data: this.data,
        rememberMe: true,
        redirect: '/',
        fetchUser: true,
        success: function success() {},
        error: function error(res) {
          this.data.username = this.data.password = '';
        }
      });
    }
  }
});

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(144);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(144);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'studentfee_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */],
      showProcessing: false
    };
  }
});

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(145);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(145);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    OverviewLayout: __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(146);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'scholarshippayment_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  computed: {
    isPlanned: function isPlanned() {
      return this.tableCfg.subType(this) === 'planned';
    },
    isNumbered: function isNumbered() {
      return this.tableCfg.subType(this) === 'numbered';
    }
  },
  methods: {
    resetExport: function resetExport(rec) {
      var _this = this;

      rec.exported_userid = null;
      rec.exported_timestamp = null;
      this.api.putUpdate(this.tableCfg.detailApiUrl + rec.id, rec, function (data) {
        _this.$router.push({ name: _this.detailRouterUrl, params: { id: rec.id } });
      }, 'resetting export', this.$refs.layout.$refs.alert);
    }
  }
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(146);




function calcUniversityPeriod(dt) {
  var m = dt.getMonth();
  var y = dt.getFullYear();
  var result;
  if (m > 7) result = y + '-' + (y + 1) + '/01';else if (m < 2) result = y - 1 + '-' + y + '/01';else result = y - 1 + '-' + y + '/02';

  return result;
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */],
      universityFeePeriod: calcUniversityPeriod(new Date())
    };
  },

  computed: {
    isNumbered: function isNumbered() {
      return this.tableCfg.subType(this) === 'numbered';
    },
    isPlanned: function isPlanned() {
      return this.tableCfg.subType(this) === 'planned';
    }
  },
  methods: {
    exportPayments: function exportPayments() {
      this.exportSelection('/scholarship_payments/export_payments', 'ExportPayments.xlsx');
      this.$refs.overview.refreshTable();
    },
    checkUniversityFees: function checkUniversityFees() {
      this.api.downloadPost('/scholarship_payments/export_university_fee_payments', { period: this.universityFeePeriod }, 'University_fees.zip');
    },
    createPayments: function createPayments() {
      this.postWithSelection('/scholarship_payments/create_payments', 'Creating Payments', this.$refs.overview.refreshTable);
    },
    createBatchPayments: function createBatchPayments(id, okFnc, errorFnc) {
      this.api.post('/scholarship_payments/' + id + '/create_payment', {}, okFnc, errorFnc, this.$refs.overview.alert);
    }
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(147);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tabIndex: 0,
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(147);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(148);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(148);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'studentfee_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */],
      showProcessing: false
    };
  }
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__ = __webpack_require__(149);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'university_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_1__FieldDefs_js__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(149);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'university_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    OverviewLayout: __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(150);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user_detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_DetailMixin__["a" /* default */]],
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */],
      pw1: '',
      pw2: '',
      pwmessage: ''
    };
  },

  methods: {
    okPassword: function okPassword(event) {
      if (this.pw1 === this.pw2) {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].putUpdate('/users/' + this.$refs.layout.rec.id, { usr_login_password: this.pw1 }, function (data) {}, 'setting password', this.$refs.layout.$refs.alert);
      } else {
        event.cancel();
      }
    }
  }
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__ = __webpack_require__(150);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user_overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_OverviewMixin__["a" /* default */]],
  components: {
    OverviewLayout: __WEBPACK_IMPORTED_MODULE_1__components_OverviewLayout___default.a
  },
  data: function data() {
    return {
      tableCfg: __WEBPACK_IMPORTED_MODULE_2__FieldDefs_js__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lstDeveloper = ['Developer'];
var lstAdministrator = ['Developer', 'Administrator'];
var lstUser = ['Developer', 'Administrator', 'User'];
var lstReader = ['Developer', 'Administrator', 'User', 'Reader'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivilegeMixin',
  computed: {
    privRole: function privRole() {
      return this.$auth.user().userrole_name;
    },
    privDeveloper: function privDeveloper() {
      return lstDeveloper.includes(this.privRole);
    },
    privAdministrator: function privAdministrator() {
      return lstAdministrator.includes(this.privRole);
    },
    privUser: function privUser() {
      return lstUser.includes(this.privRole);
    },
    privReader: function privReader() {
      return lstReader.includes(this.privRole);
    }
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);



/* harmony default export */ __webpack_exports__["a"] = ({
  createValidator: function createValidator(context) {
    var validator = new __WEBPACK_IMPORTED_MODULE_1_vee_validate__["Validator"]();
    validator.orgrec = {};
    return validator;
  },
  addValidation: function addValidation(validator, rec, fieldName, alias, rules) {
    validator.attach(fieldName, rules, { alias: alias });
  },
  setOriginalRec: function setOriginalRec(validator, rec) {
    validator.orgrec = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(validator.orgrec, rec);
  },
  validateValue: function validateValue(validator, fieldName, value) {
    return validator.validate(fieldName, value);
  },
  validateAll: function validateAll(validator, rec, okFnc, failFnc) {
    var _this = this;

    validator.validateAll(rec).then(function (result) {
      if (result) {
        if (okFnc) {
          okFnc(_this.getChangedFields(validator, rec));
        }
      } else {
        console.log('Correct them errors!', validator);
        if (failFnc) {
          failFnc(validator);
        }
      }
    });
  },
  getChangedFields: function getChangedFields(validator, rec) {
    var result = {};
    if (rec.id) result.id = rec.id;
    for (var k in rec) {
      var cur = rec[k];
      var prev = validator.orgrec[k] === undefined ? '' : validator.orgrec[k];

      if (cur !== prev) {
        result[k] = cur;
      }
    }
    return result;
  }
});

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 204,
	"./af.js": 204,
	"./ar": 211,
	"./ar-dz": 205,
	"./ar-dz.js": 205,
	"./ar-kw": 206,
	"./ar-kw.js": 206,
	"./ar-ly": 207,
	"./ar-ly.js": 207,
	"./ar-ma": 208,
	"./ar-ma.js": 208,
	"./ar-sa": 209,
	"./ar-sa.js": 209,
	"./ar-tn": 210,
	"./ar-tn.js": 210,
	"./ar.js": 211,
	"./az": 212,
	"./az.js": 212,
	"./be": 213,
	"./be.js": 213,
	"./bg": 214,
	"./bg.js": 214,
	"./bn": 215,
	"./bn.js": 215,
	"./bo": 216,
	"./bo.js": 216,
	"./br": 217,
	"./br.js": 217,
	"./bs": 218,
	"./bs.js": 218,
	"./ca": 219,
	"./ca.js": 219,
	"./cs": 220,
	"./cs.js": 220,
	"./cv": 221,
	"./cv.js": 221,
	"./cy": 222,
	"./cy.js": 222,
	"./da": 223,
	"./da.js": 223,
	"./de": 226,
	"./de-at": 224,
	"./de-at.js": 224,
	"./de-ch": 225,
	"./de-ch.js": 225,
	"./de.js": 226,
	"./dv": 227,
	"./dv.js": 227,
	"./el": 228,
	"./el.js": 228,
	"./en-au": 229,
	"./en-au.js": 229,
	"./en-ca": 230,
	"./en-ca.js": 230,
	"./en-gb": 231,
	"./en-gb.js": 231,
	"./en-ie": 232,
	"./en-ie.js": 232,
	"./en-nz": 233,
	"./en-nz.js": 233,
	"./eo": 234,
	"./eo.js": 234,
	"./es": 236,
	"./es-do": 235,
	"./es-do.js": 235,
	"./es.js": 236,
	"./et": 237,
	"./et.js": 237,
	"./eu": 238,
	"./eu.js": 238,
	"./fa": 239,
	"./fa.js": 239,
	"./fi": 240,
	"./fi.js": 240,
	"./fo": 241,
	"./fo.js": 241,
	"./fr": 244,
	"./fr-ca": 242,
	"./fr-ca.js": 242,
	"./fr-ch": 243,
	"./fr-ch.js": 243,
	"./fr.js": 244,
	"./fy": 245,
	"./fy.js": 245,
	"./gd": 246,
	"./gd.js": 246,
	"./gl": 247,
	"./gl.js": 247,
	"./gom-latn": 248,
	"./gom-latn.js": 248,
	"./he": 249,
	"./he.js": 249,
	"./hi": 250,
	"./hi.js": 250,
	"./hr": 251,
	"./hr.js": 251,
	"./hu": 252,
	"./hu.js": 252,
	"./hy-am": 253,
	"./hy-am.js": 253,
	"./id": 254,
	"./id.js": 254,
	"./is": 255,
	"./is.js": 255,
	"./it": 256,
	"./it.js": 256,
	"./ja": 257,
	"./ja.js": 257,
	"./jv": 258,
	"./jv.js": 258,
	"./ka": 259,
	"./ka.js": 259,
	"./kk": 260,
	"./kk.js": 260,
	"./km": 261,
	"./km.js": 261,
	"./kn": 262,
	"./kn.js": 262,
	"./ko": 263,
	"./ko.js": 263,
	"./ky": 264,
	"./ky.js": 264,
	"./lb": 265,
	"./lb.js": 265,
	"./lo": 266,
	"./lo.js": 266,
	"./lt": 267,
	"./lt.js": 267,
	"./lv": 268,
	"./lv.js": 268,
	"./me": 269,
	"./me.js": 269,
	"./mi": 270,
	"./mi.js": 270,
	"./mk": 271,
	"./mk.js": 271,
	"./ml": 272,
	"./ml.js": 272,
	"./mr": 273,
	"./mr.js": 273,
	"./ms": 275,
	"./ms-my": 274,
	"./ms-my.js": 274,
	"./ms.js": 275,
	"./my": 276,
	"./my.js": 276,
	"./nb": 277,
	"./nb.js": 277,
	"./ne": 278,
	"./ne.js": 278,
	"./nl": 280,
	"./nl-be": 279,
	"./nl-be.js": 279,
	"./nl.js": 280,
	"./nn": 281,
	"./nn.js": 281,
	"./pa-in": 282,
	"./pa-in.js": 282,
	"./pl": 283,
	"./pl.js": 283,
	"./pt": 285,
	"./pt-br": 284,
	"./pt-br.js": 284,
	"./pt.js": 285,
	"./ro": 286,
	"./ro.js": 286,
	"./ru": 287,
	"./ru.js": 287,
	"./sd": 288,
	"./sd.js": 288,
	"./se": 289,
	"./se.js": 289,
	"./si": 290,
	"./si.js": 290,
	"./sk": 291,
	"./sk.js": 291,
	"./sl": 292,
	"./sl.js": 292,
	"./sq": 293,
	"./sq.js": 293,
	"./sr": 295,
	"./sr-cyrl": 294,
	"./sr-cyrl.js": 294,
	"./sr.js": 295,
	"./ss": 296,
	"./ss.js": 296,
	"./sv": 297,
	"./sv.js": 297,
	"./sw": 298,
	"./sw.js": 298,
	"./ta": 299,
	"./ta.js": 299,
	"./te": 300,
	"./te.js": 300,
	"./tet": 301,
	"./tet.js": 301,
	"./th": 302,
	"./th.js": 302,
	"./tl-ph": 303,
	"./tl-ph.js": 303,
	"./tlh": 304,
	"./tlh.js": 304,
	"./tr": 305,
	"./tr.js": 305,
	"./tzl": 306,
	"./tzl.js": 306,
	"./tzm": 308,
	"./tzm-latn": 307,
	"./tzm-latn.js": 307,
	"./tzm.js": 308,
	"./uk": 309,
	"./uk.js": 309,
	"./ur": 310,
	"./ur.js": 310,
	"./uz": 312,
	"./uz-latn": 311,
	"./uz-latn.js": 311,
	"./uz.js": 312,
	"./vi": 313,
	"./vi.js": 313,
	"./x-pseudo": 314,
	"./x-pseudo.js": 314,
	"./yo": 315,
	"./yo.js": 315,
	"./zh-cn": 316,
	"./zh-cn.js": 316,
	"./zh-hk": 317,
	"./zh-hk.js": 317,
	"./zh-tw": 318,
	"./zh-tw.js": 318
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QceCTEHRMI3pQAABPtJREFUSMetl2tsVFUQx393Tx+0YHkUCwZQXkowIEFQ5GUkuMrFcGPRYALhBEQJdY08JZgCRqIfihgRuIumiOZ+IVFi9Bjd4KVowsNCwA8IISBQxCAmWKyEQik9e/3ArNmsbXnY8+XcPTtz5s7Mf/4zF25hKS/oEJnMcm5VUHmBA8SAMmCI6P4MXASwRqf/t1HlBVijUV4wAlgJjAb6tyIaAaeAWqDSGn02W/+2PVVesAZYBTQDB4HaKHIOpq36HaL8mEr3dZxoDPAIMErUtgArrNH1bRm+mdG+QJW1Sleu3JhuaLirE9ATGAykgcOxWPrqxqdrmuhxGjVhz05gkqRhrDW69rY8TaTi+G6Yea4AXgIeBDrliF4GjgAbfDfcFvOCcQ7sBIqA+dbo6lyPnfYMJlLxIcC3wEDgV2AvEAJngELJ8ZPARKAXsFep9AsbZiTPq8f3nwAGAaOt0Ydu1dOxwD7gOrDId8NkO7IOUAUsk/wP9NfPq1eFzU0i0t0a3ZCRj7VxyQBgt4RumO+GyUQq3mbufTeMfDdcLggvBE4uXZEsxeFhyf172bXs5IYVUEC95K6P74b1bZVTa2eJVPw+4DRQ47vhU8oLfgQeA7paoy+1Gt5EKu5KHit8N/ywHWSXAJ2BBmBENlITqfj7wMe+Gx4R2Qj40hpdDpDXyn3fAI0ZgxKSAklFBDRboyMxWCollAK6Ky/Ij8XSke/OWZwTkT3ASOUFMWt0Oje8I4GfgJm+G25TXtAN2A70Bv4GSoCrwGuyu8As4H5BtgLqrNFzczh5vegUAC25QBoq+wHZq4EPrNHDrNHjrdHDgReBbVKHdUA58Kc1erI1+glgbjb5i6f7JZWF1mjylBcooMCe690E73aRErkiOqOAIuUFFTlk0AVoAfLFu1iOkdx1SvbhQG0e8CxQRa8LE8T9DIkDdJPQXMk6A3hHPI1y5Nta12XPzwCpBRio8mwJ0CRvXShCh4Gz1ugTWTnqAfQQoxmDhTcx2k/2oxmjDRLvrlHEccdBAfcK7b0K7FJecBS4AHQFHgKSwPeAY40+obzgsvKCELDAGWv0ghwgPSo/LykvIAYcl4PpyanhbnlOSn6OSF7XCXg2AxOt0VXy1ikpi/7ACum7G7NdlBwPB/4A0tboG+SgvKARKLZGO4lUfB2wFJjku+EP3MFKpOLjgWO+G16U+zP9eJw1+l/UTZM/K6LIWS01WH2HBkuAHYCRO9cKgBZlkB2TmO8CzgErk1O/uwIkgMGJVLxGLqE9ws8yeDc3emlnx4neKCj/tAxYAhyyRh/4D+ErL5gmb7fLGj05kYovlVz+ApT7bni0vYYvI8t2oA8ww3fDL5QX1AJjcnuqkzOErQVeB962Rq9KpOIzBTxFQA2wSYB3WUihWNC8UBp5PQ6z/CnhDuUFATAbeMUavbnVJi6ux4DPgelAtT08dOGSrcv6X7tWUAk8I2SBIDFPyB4pp+09S/9a/Vbl8pgqakoCzwFbrNEv33RcEVr8CJgnM+0ca2Z/vbhmUmFzc/50adRlIv6b40T7N03Z+ZXozpRpsAhYY41+83bn3ueBtcAA4FgUOZ+lr+eFNBafo65fA0Qw6GwpxVf7qfyWqUL8g2UAX2CN3nenI2hnYD4wVy4sEqq8IPR3j5RDo5DFVuATa3RzR31WPACMk8mwTHTPAyeBvdboOjpydfQH1D8pKfpfcRG5PAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAeCAYAAABe3VzdAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QceCTEiD8bj4gAABTJJREFUWMPtlmlMVFcUx//3DTPDTBEHBlG2mWFxREfcGUVLi03VYljEtC5obHBJ1RLigjZ1SU3aT/3QWGuTtmrLUjfQaGX50Ni01raooI64oEO1yAAuswozwMC8d/oBoWOBBNoGSepJbu7Lveec/N45595zGYZA3EXLqgVzTRxAvTcJrQgKDpYtO+vqy5YbCkDB7gFv7mfYmFwydoOTrzn7wfMDbBNATgHU8rfhFEBOHnxdFaj5cUiP/qWVPbPPUACik0Aeoc8txvEgtw1w3VIJ5+endNXEYxGA7zj9t0MDKLgEkINHXzVIDOBNP4ARkpmSJXuzD1mK/40MSQS5nnh4RZWGEaDpCUObTQQQ9eROHcCDY8MEsJ1naPUqQcYAEj0NLQdAAjApwHyfEyAeEchEz5wR/gEDWBdsRz2HTj8OkHLdp4paPvqeILQOEaAAgEdPiuFVk8QAdABof6oHACRi/H0LQO3/k1NsLjnj13KjOgmi3v9LPM83X65yAfjjuQHaf/sl7NGpEyVMJOpPZcPLN2u/GJzXzP8O8KVxseKAxFfBRP1WjNTxTSEU+ll4IS+kP6k11gZtysmJAIBOjyewqrIyqi89ItISkeTpNyOicCKK6d6vrr6uNd4xxnjbOByOMdkb3408+OVXUV5+BgZWXlo2b/fOnbwqNExI0Osdu3bs+DVGE0mhwaMpPSWVyk6XS544HCkzZ8RvzkhNo9Dg0TR7VkIcAGzZtNkvboKOpkyMIwAw3r69LHCEPwUHBNLBAwfmP2m2S97f/l5r2OgxFBESSqqQUIqfOu0xEU0Z8ENj4/r12YX5BUwsFjOL2SItyMu3KJVK+Pr6UvW1a9j32SdVKzMzFa0u12yDwQA/Pz/IZTIQEau9c8fobGmBTCYDANSb6jukvr4Y4e+PRlODcnZ8gvHokSOyeL0e2Tk5cyRSaZvVah2lGxdbOGDAugZTukgk4hljkMvl1vqmxvSLl6uYMiiIcRyHWmNt3JmysrLrNbfe4riua4TneazNWr3q6tWrId1rACAWSwQigkKhgMFgWOhyudRdfmVZDx8+rPEf6S8BgEmTJ4kH9VTr7owEYqdOnhQDgE6nyyMiuDvcOHP69FJvI4vFYn/Q1JSXsXgxPB5Pz/rFigtz5HI5SspLpzqdTr2Pjw84jkPR8aKKcz+fs2fn5Pjcq7/PjhUXxw4WsHd/F/jOrllA2qJFN72LW6sde85oNJq25G7dJwgCCAQi8vl8//7crNVZxaFh4QaX02nrtl+7bl3i3k/3stVr1gAAThQX458BErApO9sDAHV195cyxjBeN0FgjJ3/C1zAxYoLUW8uWfKh1Wp1M8bgbndTekpq57Tp0yt279mzxOGwQ6vVGtvb28FxHJqamrYlJr6iAICmxgblieNFC9va2gacZkSrNZ5otYZmzohvrrx0aU9K8kJLlEpNIaOCaXvutre99ChKpaZVmSvuAUBVZeXHqtAwilKpafqUqR4iknr7zUhNo2i1hmI0kRQZoRJWZa4gTXgEaaOiHUQ0ctCPBbvNJs5IS4+XSqXnFyS/4XwlKenQ8uXLf/JS+ZHjOOu8BQu2Fhw5DAA3AJQoAgIkeYUF7zDG3BcqKjArIQEAsGP3rsDjR48dunv39wyeF5jZbLYlzU06LJZIvwbQMqgIxmgiabJuYoP3ekF+vrcOe/ZiNz7jI3fL1l5+y0pK0c9lP7guEqOJ9ESrNRQ3foKpvLRUMpw6HPf63NcaeZ4XAYDH4wnfuH6D8cqVqtjhAvgnLExdHAbf61cAAAAASUVORK5CYII="

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(690),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-aae1a5de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  "data-v-cac1ac24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  "data-v-51aa0b2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  "data-v-3c50b159",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  "data-v-31359386",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.showProcessing,
      "label": "Processing"
    }
  }), _vm._v(" "), _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Type",
      "field": "scholarship_type",
      "optionListApiUrl": '/scholarships_type/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Year",
      "field": "year",
      "optionListApiUrl": '/contracts_year/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bar-top'), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('h2', [_vm._v(_vm._s(_vm.detailTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-3"
  }, [(_vm.isReadOnly && _vm.privUser) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.detailRouterUrl,
          params: {
            id: _vm.rec.id
          },
          query: {
            mode: 'edit'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.detailRouterUrl,
          params: {
            id: _vm.rec.id
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Undo Edit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit && !(_vm.tableCfg.disableDelete && _vm.tableCfg.disableDelete(_vm.rec)) && _vm.privUser) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalDeleteOk",
      modifiers: {
        "modalDeleteOk": true
      }
    }],
    attrs: {
      "variant": "default",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm",
      "disabled": _vm.isSaveDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitRecord()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.backToOverview()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Overview\n        ")]), _vm._v(" "), _vm._t("ExtraOptions", null, {
    rec: _vm.rec
  })], 2)]), _vm._v(" "), _c('div', [_vm._t("FormLayout", [_vm._v("\n      Here is the form\n    ")], {
    rec: _vm.rec
  })], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modalDeleteOk",
      "title": 'Delete ' + this.deleteTitle,
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.deleteRecord
    }
  }, [_vm._v("\n    Are you sure you want to delete this " + _vm._s(_vm.deleteTitle) + "?\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Intake",
            "field": "intake",
            "optionListApiUrl": '/contracts_intake/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Scholarship",
            "field": "scholarship_id",
            "optionListApiUrl": '/scholarships/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Year",
            "field": "year",
            "optionListApiUrl": '/contracts_year/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Date",
            "field": "milestone_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Amount",
            "field": "milestone_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bar-top'), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.overviewTitle))]), _vm._v(" "), _c('div', {
    staticClass: " col-md-2"
  }, [(_vm.paginationData) ? _c('div', {
    staticClass: "paginationInfo"
  }, [_vm._v("\n          " + _vm._s(_vm.paginationData.from) + "-" + _vm._s(_vm.paginationData.to) + " of " + _vm._s(_vm.paginationData.total) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.paginationData) ? _c('div', {}, [_c('button', {
    staticClass: "btn btn-default btn-sm ",
    attrs: {
      "disabled": !_vm.paginationData || _vm.paginationData.current_page === 1
    },
    on: {
      "click": function($event) {
        _vm.table.gotoPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "i": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": !_vm.paginationData || _vm.paginationData.current_page === _vm.paginationData.last_page
    },
    on: {
      "click": function($event) {
        _vm.table.gotoNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "i": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchRec[_vm.tableCfg.quickFilterField]),
      expression: "searchRec[tableCfg.quickFilterField]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.tableCfg.quickFilterName
    },
    domProps: {
      "value": (_vm.searchRec[_vm.tableCfg.quickFilterField])
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchRec, _vm.tableCfg.quickFilterField, $event.target.value)
      }, _vm.quickFilterChanged],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.doQuickFilter($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilter($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.tableCfg.advancedSearch) ? _c('b-form-checkbox', {
    model: {
      value: (_vm.advancedFilter),
      callback: function($$v) {
        _vm.advancedFilter = $$v
      },
      expression: "advancedFilter"
    }
  }, [_vm._v("Advanced")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.disableNew) ? _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": _vm.gotoNewDetail
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), _vm._t("ExtraOptions")], 2)]), _vm._v(" "), (_vm.tableCfg.advancedSearch && _vm.advancedFilter) ? _c('b-card', {
    staticClass: "mb-2"
  }, [(_vm.advancedFilter) ? _vm._t("AdvancedFilter", [_vm._v("\n        Here is the advanced filter\n      ")]) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.batchMode) ? _c('b-progress', {
    attrs: {
      "value": _vm.batchCounter,
      "max": _vm.batchMax,
      "show-progress": true,
      "show-value": true
    }
  }) : _vm._e(), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "apiUrl": _vm.apiUrl,
      "fields": _vm.fields,
      "sortOrder": _vm.tableCfg.sortOrder,
      "perPage": 50,
      "initialPage": _vm.findInitialPage(),
      "multiSort": true,
      "appendParams": _vm.appendParams,
      "css": _vm.css.table
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:load-error": _vm.onLoadError
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "disabled": !_vm.privUser
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: _vm.detailRouterUrl,
                params: {
                  id: props.rowData.id
                },
                query: {
                  mode: 'edit'
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]), _vm._v(" "), _vm._t("ExtraRowActions", null, {
          rowData: props.rowData
        })], 2)]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoices/download_report', 'Invoices.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoices/download_report_open', 'Invoices Open.xlsx')
            }
          }
        }, [_vm._v("Export Open Invoices")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), (_vm.privAdministrator && (_vm.isPlanned || _vm.isNumbered)) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]) : _vm._e(), _vm._v(" "), (_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCreateInvoiceOk.show()
            }
          }
        }, [_vm._v("Create Invoice")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmail, 'document_reference')
            }
          }
        }, [_vm._v("Send Email")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmailReminder, 'document_reference')
            }
          }
        }, [_vm._v("Send Email Reminder")]) : _vm._e()], 2) : _vm._e()]
      }
    }, {
      key: "ExtraRowActions",
      fn: function(props) {
        return [(_vm.isNumbered) ? _c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "disabled": !_vm.privUser
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'invoicepayment',
                params: {
                  id: 'new'
                },
                query: {
                  invoice_id: props.rowData.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-money"
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Contract/Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Planned before",
      "type": "date",
      "field": "planned_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Expired after",
      "type": "date",
      "field": "expired_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Open",
      "field": "open",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Email Sent",
      "field": "email_sent",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (!_vm.isCreditNote) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Document Type",
      "field": "document_type_id",
      "optionListApiUrl": '/document_types_invoices/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCreditNote) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Document Type",
      "field": "document_type_id",
      "optionListApiUrl": '/document_types_creditnotes/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Pro Forma",
      "field": "pro_forma",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Program",
      "field": "program_id",
      "optionListApiUrl": '/programs/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Round",
      "field": "application_round",
      "optionListApiUrl": '/contracts_round/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Instalments",
      "field": "instalments",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalCreateInvoiceOk",
    attrs: {
      "title": "Create Invoices",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.createPDF, 'document_reference')
      }
    }
  }, [_vm._v("\n    Are you sure you want to create these invoices?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/invoices/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.bulkRec,
      "type": "money",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Planned Date",
      "field": "planned_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Expiration Date",
      "field": "expiration_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Extended Deadline",
      "field": "extended_deadline_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Login",
            "field": "usr_login_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "First Name",
            "field": "usr_first_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Last Name",
            "field": "usr_last_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Role",
            "field": "usr_role_id",
            "optionListApiUrl": '/userroles/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Active",
            "field": "usr_active",
            "type": "boolean",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Filter Active Contracts",
            "field": "usr_filter_active",
            "type": "boolean",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSetPassword.show()
            }
          }
        }, [_vm._v("Set Password")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-modal', {
    ref: "modalSetPassword",
    attrs: {
      "title": "Set Password"
    },
    on: {
      "ok": _vm.okPassword
    }
  }, [_c('b-form', {
    ref: "pwform",
    staticClass: "col-md-6 offset-md-2",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "data-vv-as": "PW1",
      "name": "pw1"
    },
    model: {
      value: (_vm.pw1),
      callback: function($$v) {
        _vm.pw1 = $$v
      },
      expression: "pw1"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password",
      "data-vv-as": "PW2",
      "name": "pw2"
    },
    model: {
      value: (_vm.pw2),
      callback: function($$v) {
        _vm.pw2 = $$v
      },
      expression: "pw2"
    }
  }), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.pw1 !== _vm.pw2
    }
  }, [_vm._v("Passwords do not match")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    attrs: {
      "variant": _vm.alertVariant,
      "show": _vm.alertShow,
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.dismissMessage
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.alertInfo)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [(!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Number",
            "field": "number",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Contract/Student",
            "field": "contract_id",
            "optionListApiUrl": '/contracts/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), ((props.rec.scholarship_payment_type_id === 2)) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice/Credit Note",
            "field": "linked_invoice_id",
            "optionListApiUrl": '/invoices_credit_notes/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Type",
            "field": "scholarship_payment_type_id",
            "optionListApiUrl": '/scholarship_payment_types/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Period",
            "field": "period",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount",
            "field": "amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || (_vm.isEdit && !_vm.isPlanned),
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Date",
            "field": "planned_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Date",
            "field": "payment_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), ((props.rec.scholarship_payment_type_id === 5)) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "University",
            "field": "university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Exported",
            "field": "exported_timestamp",
            "field2": "exported_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.privUser && _vm.isNumbered) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isNumbered) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.resetExport(props.rec)
            }
          }
        }, [_vm._v("Reset Export")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-md-12"
  }, [_vm._v("\n  from\n    "), _c('datepicker', {
    staticClass: "col-md-5",
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _vm._v("\n  to\n    "), _c('datepicker', {
    staticClass: "col-md-5",
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    class: ['vuetable', _vm.css.tableClass]
  }, [_c('thead', [_c('tr', [_vm._l((_vm.tableFields), function(field) {
    return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__checkbox') ? _c('th', {
      class: ['vuetable-th-checkbox-' + _vm.trackBy, field.titleClass]
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkCheckboxesState(field.name)
      },
      on: {
        "change": function($event) {
          _vm.toggleAllCheckboxes(field.name, $event)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__component') ? _c('th', {
      class: ['vuetable-th-component-' + _vm.trackBy, field.titleClass, {
        'sortable': _vm.isSortable(field)
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__slot') ? _c('th', {
      class: ['vuetable-th-slot-' + _vm.extractArgs(field.name), field.titleClass, {
        'sortable': _vm.isSortable(field)
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__sequence') ? _c('th', {
      class: ['vuetable-th-sequence', field.titleClass || ''],
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot'])) ? _c('th', {
      class: ['vuetable-th-' + field.name, field.titleClass || ''],
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e()] : [_c('th', {
      class: ['vuetable-th-' + field.name, field.titleClass, {
        'sortable': _vm.isSortable(field)
      }],
      attrs: {
        "id": '_' + field.name
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    })]] : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "vuetable-body"
  }, [_vm._l((_vm.tableData), function(item, index) {
    return [_c('tr', {
      class: _vm.onRowClass(item, index),
      attrs: {
        "item-index": index,
        "render": _vm.onRowChanged(item)
      },
      on: {
        "dblclick": function($event) {
          _vm.onRowDoubleClicked(item, $event)
        },
        "click": function($event) {
          _vm.onRowClicked(item, $event)
        }
      }
    }, [_vm._l((_vm.tableFields), function(field) {
      return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__sequence') ? _c('td', {
        class: ['vuetable-sequence', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderSequence(index))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__handle') ? _c('td', {
        class: ['vuetable-handle', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__checkbox') ? _c('td', {
        class: ['vuetable-checkboxes', field.dataClass]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowSelected(item, field.name)
        },
        on: {
          "change": function($event) {
            _vm.toggleCheckbox(item, field.name, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__component') ? _c('td', {
        class: ['vuetable-component', field.dataClass]
      }, [_c(_vm.extractArgs(field.name), {
        tag: "component",
        attrs: {
          "row-data": item,
          "row-index": index,
          "row-field": field.sortField
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__slot') ? _c('td', {
        class: ['vuetable-slot', field.dataClass]
      }, [_vm._t(_vm.extractArgs(field.name), null, {
        rowData: item,
        rowIndex: index,
        rowField: field.sortField
      })], 2) : _vm._e()] : [(_vm.hasCallback(field)) ? _c('td', {
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.applyLink(_vm.callCallback(field, item), item, field))
        },
        on: {
          "click": function($event) {
            _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            _vm.onCellDoubleClicked(item, field, $event)
          }
        }
      }) : _c('td', {
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.applyLink(_vm.getObjectValue(item, field.name, ''), item, field))
        },
        on: {
          "click": function($event) {
            _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            _vm.onCellDoubleClicked(item, field, $event)
          }
        }
      })]] : _vm._e()]
    })], 2), _vm._v(" "), (_vm.useDetailRow) ? [(_vm.isVisibleDetailRow(item[_vm.trackBy])) ? _c('tr', {
      class: [_vm.css.detailRowClass],
      on: {
        "click": function($event) {
          _vm.onDetailRowClick(item, $event)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": _vm.detailRowTransition
      }
    }, [_c('td', {
      attrs: {
        "colspan": _vm.countVisibleFields
      }
    }, [_c(_vm.detailRowComponent, {
      tag: "component",
      attrs: {
        "row-data": item,
        "row-index": index
      }
    })], 1)])], 1) : _vm._e()] : _vm._e()]
  }), _vm._v(" "), (_vm.displayEmptyDataRow) ? [_c('tr', [_c('td', {
    staticClass: "vuetable-empty-result",
    attrs: {
      "colspan": _vm.countVisibleFields
    }
  }, [_vm._v(_vm._s(_vm.noDataTemplate))])])] : _vm._e(), _vm._v(" "), (_vm.lessThanMinRows) ? _vm._l((_vm.blankRows), function(i) {
    return _c('tr', {
      staticClass: "blank-row"
    }, [_vm._l((_vm.tableFields), function(field) {
      return [(field.visible) ? _c('td', [_vm._v(" ")]) : _vm._e()]
    })], 2)
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoice_payments/download_report', 'Invoices_payments.xlsx')
            }
          }
        }, [_vm._v("Export Selection")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n        ")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmail, 'id')
            }
          }
        }, [_vm._v("Send Payment Confirmation")])], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Contract/Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Email Sent",
      "field": "email_sent",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Payment date after",
      "type": "date",
      "field": "payment_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    attrs: {
      "label": "Student",
      "field": "student_id",
      "optionListApiUrl": '/students/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "User",
      "field": "user_id",
      "optionListApiUrl": '/users/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Event Type",
      "field": "eventtype_id",
      "optionListApiUrl": '/logging_types/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Event Time",
      "field": "eventtime_date_range",
      "type": "daterange",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.showing) ? _c('div', {
    class: ( _obj = {}, _obj[_vm.overlayClass] = _vm.overlay, _obj )
  }, [_vm._t("loading-container", [_c('div', {
    class: _vm.loaderClass
  }, [_vm._t("loading-text", [_c('div', {
    staticClass: "pulled-left",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })]), _vm._v(" "), _vm._t("loading-spinner", [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "spinner-container"
  }, [_c('div', {
    staticClass: "spinner-layer spinner-layer--blue"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--red"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--yellow"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--green"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])])])])])], 2)])], 2) : _vm._e()])
  var _obj;
},staticRenderFns: []}

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Short Name",
            "field": "shortname",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Name",
            "field": "name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Name",
            "field": "payment_holder_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder IBAN",
            "field": "payment_holder_iban",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Swift",
            "field": "payment_holder_swift",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Address",
            "field": "payment_holder_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Bank Address",
            "field": "payment_bank_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Amount",
            "field": "payment_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/students/download_report', 'Students.xlsx')
            }
          }
        }, [_vm._v("Export Selection")])], 2)]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Name",
      "field": "name",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Email Address",
      "field": "email_address",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Address",
      "field": "address",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info requested before",
      "type": "date",
      "field": "bankinfo_requested_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info updated before",
      "type": "date",
      "field": "bankinfo_updated_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "col-md-4 offset-md-4 justify-content-center login",
    attrs: {
      "title": "Login"
    }
  }, [_c('form', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "login",
      "placeholder": "Enter your name"
    },
    model: {
      value: (_vm.data.username),
      callback: function($$v) {
        _vm.data.username = $$v
      },
      expression: "data.username"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Enter your password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.data.password = $$v
      },
      expression: "data.password"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Intake",
            "field": "intake",
            "optionListApiUrl": '/contracts_intake/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Scholarship",
            "field": "scholarship_id",
            "optionListApiUrl": '/scholarships/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Registration Fee",
            "field": "registration_fee_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Participation Fee Y1",
            "field": "participationfee1_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Participation Fee Y2",
            "field": "participationfee2_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Adminstration Fee Y1",
            "field": "administrationfee1_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Adminstration Fee Y2",
            "field": "administrationfee2_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Monthly Allowance",
            "field": "administrationfee2_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label-text-align": "right",
      "label-cols": _vm.labelCols,
      "label": _vm.label + ':',
      "horizontal": "",
      "state": _vm.veeState,
      "feedback": _vm.veeFeedBack
    }
  }, [(_vm.static || _vm.isReadOnly) ? _c('div', {
    staticClass: "text-left static-field",
    domProps: {
      "innerHTML": _vm._s(_vm.getStaticValue())
    }
  }) : _c('div', [(_vm.type === 'simpledate') ? _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.vvalidate),
      expression: "vvalidate"
    }],
    attrs: {
      "type": "date",
      "name": _vm.field,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'date') ? _c('datepicker', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "clear-button": _vm.hasClearButton,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'daterange') ? _c('daterange', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'boolean' && _vm.hasNull) ? _c('b-form-select', {
    staticClass: "float-right text-right",
    attrs: {
      "name": _vm.field,
      "options": _vm.booleanOptionList,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'boolean') ? _c('b-form-checkbox', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : ((_vm.optionList !== null || _vm.optionListApiUrl !== null) && _vm.finalOptionList.length) ? _c('multiselect', {
    attrs: {
      "track-by": "value",
      "name": _vm.field,
      "options": _vm.finalOptionList,
      "state": _vm.veeState,
      "label": "text",
      "showLabels": false,
      "data-vv-name": _vm.field,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'textarea') ? _c('b-form-textarea', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly,
      "rows": 4
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'money') ? _c('b-input-group', {
    attrs: {
      "left": "€"
    }
  }, [_c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "type": "number",
      "step": "0.01",
      "data-number-to-fixed": "2",
      "data-number-stepfactor": "100",
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, _vm._n($$v))
      },
      expression: "rec[field]"
    }
  })], 1) : _c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "type": _vm.type,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice/Contract/Student",
            "field": "invoice_id",
            "optionListApiUrl": '/invoices/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount Paid",
            "field": "amount_paid",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onCalcNetAmount(props.rec, $event)
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Commission",
            "field": "commission",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onCalcNetAmount(props.rec, $event)
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Net Amount",
            "field": "net_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Date",
            "field": "payment_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "PDF Creation",
            "field": "pdf_creation_timestamp",
            "field2": "pdf_creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "vclass": "col-md-6",
            "label": "Payment Confirmation",
            "field": "payment_confirmation_timestamp",
            "field2": "payment_confirmation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (props.rec && _vm.privDeveloper && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createPDF(props.rec)
            }
          }
        }, [_vm._v("Create PDF")]) : _vm._e(), _vm._v(" "), (props.rec && props.rec.number !== null && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadPDF(props.rec)
            }
          }
        }, [_vm._v("Download PDF")]) : _vm._e(), _vm._v(" "), (props.rec && props.rec.number !== null && _vm.privUser && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec)
            }
          }
        }, [_vm._v("Send Payment Confirmation")]) : _vm._e()], 2)]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.showProcessing,
      "label": "Processing"
    }
  }), _vm._v(" "), _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Type",
      "field": "scholarship_type",
      "optionListApiUrl": '/scholarships_type/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.showProcessing,
      "label": "Processing"
    }
  }), _vm._v(" "), _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/contracts/download_report', 'Contracts.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/contracts/download_paymentstatus', 'Balance_to_date.xlsx')
            }
          }
        }, [_vm._v("Export Payment Status")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentStatus.show()
            }
          }
        }, [_vm._v("Export Payment Status")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalImportDreamApply.show()
            }
          }
        }, [_vm._v("Import DreamApply")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalUpload.show()
            }
          }
        }, [_vm._v("Import Contracts")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalUploadBankInfo.show()
            }
          }
        }, [_vm._v("Import Bank Info")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privAdministrator) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSendBankInfoRequestOk.show()
            }
          }
        }, [_vm._v("Email bank info request scholarships")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSendPFStatusOk.show()
            }
          }
        }, [_vm._v("Send PF Status")])], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Student",
      "field": "student_id",
      "optionListApiUrl": '/students/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Type",
      "field": "scholarship_type",
      "optionListApiUrl": '/scholarships_type/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "EU/Non-EU",
      "field": "scholarship_region",
      "optionListApiUrl": '/scholarships_region/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Program",
      "field": "program_id",
      "optionListApiUrl": '/programs/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y1",
      "field": "y1_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Date",
      "type": "date",
      "field": "date",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Open",
      "field": "open",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Round",
      "field": "application_round",
      "optionListApiUrl": '/contracts_round/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Instalments",
      "field": "instalments",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info requested before",
      "type": "date",
      "field": "bankinfo_requested_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info updated before",
      "type": "date",
      "field": "bankinfo_updated_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "size": "lg",
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/contracts/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Status Date",
      "field": "contract_status_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Y1 Finished",
      "field": "year1_finished",
      "rec": _vm.bulkRec,
      "type": "boolean",
      "hasNull": true,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "University Y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.bulkRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Y2 Finished",
      "field": "year2_finished",
      "rec": _vm.bulkRec,
      "type": "boolean",
      "hasNull": true,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Start Date",
      "field": "start_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Contract Sent",
      "field": "contract_sent_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalExportPaymentStatus",
    attrs: {
      "size": "lg",
      "title": "Export Payment Status",
      "ok-title": "Export",
      "close-title": "Cancel",
      "ok-disabled": false
    },
    on: {
      "ok": _vm.exportPaymentStatus
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "From",
      "type": "date",
      "field": "start",
      "rec": _vm.exportPaymentRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Until",
      "type": "date",
      "field": "end",
      "rec": _vm.exportPaymentRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalImportDreamApply",
    attrs: {
      "size": "lg",
      "title": "Import DreamApply",
      "ok-title": "Import",
      "close-title": "Cancel",
      "ok-disabled": false
    },
    on: {
      "ok": _vm.importDreamApply
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Academic Year",
      "type": "number",
      "field": "academic_year",
      "rec": _vm.importDreamApplyRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }), _vm._v(" "), (false) ? _c('detail-field', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Enter value 1 to check for all updates (slow)",
      "type": "number",
      "field": "updates_in_last_days",
      "rec": _vm.importDreamApplyRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalUpload",
    attrs: {
      "size": "lg",
      "title": "Upload spreadsheet",
      "ok-title": "Upload",
      "close-title": "Cancel",
      "ok-disabled": _vm.documentToUpload === null || _vm.documentToUpload === undefined
    },
    on: {
      "ok": _vm.uploadExcel
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-file', {
    ref: "fileinput",
    staticClass: "col-md-10",
    attrs: {
      "placeholder": " ",
      "accept": ".xlsx"
    },
    model: {
      value: (_vm.documentToUpload),
      callback: function($$v) {
        _vm.documentToUpload = $$v
      },
      expression: "documentToUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalUploadBankInfo",
    attrs: {
      "size": "lg",
      "title": "Upload bank info XLSX or ZIP",
      "ok-title": "Upload",
      "close-title": "Cancel",
      "ok-disabled": _vm.documentToUpload === null || _vm.documentToUpload === undefined
    },
    on: {
      "ok": _vm.uploadBankInfo
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-file', {
    ref: "fileinput",
    staticClass: "col-md-10",
    attrs: {
      "placeholder": " ",
      "accept": ".xlsx,.zip"
    },
    model: {
      value: (_vm.documentToUpload),
      callback: function($$v) {
        _vm.documentToUpload = $$v
      },
      expression: "documentToUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalSendBankInfoRequestOk",
    attrs: {
      "title": "Send Bank Info Request",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.sendBankInfoRequest, 'application_number')
      }
    }
  }, [_vm._v("\n    Are you sure you want to request the bank info for the selected items?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalSendPFStatusOk",
    attrs: {
      "title": "Send Participation Fee Status",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.sendPFStatus, 'application_number')
      }
    }
  }, [_vm._v("\n    Are you sure you want to send the participation fee status email for the selected items?\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "navbar-default": "",
      "navbar-fixed-top": ""
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(652)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(651)
    }
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.privAdministrator) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Manage"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/countries"
    }
  }, [_vm._v("Countries")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/programs"
    }
  }, [_vm._v("Programs")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/universities"
    }
  }, [_vm._v("Universities")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/studentfees"
    }
  }, [_vm._v("Student Fees")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/milestones"
    }
  }, [_vm._v("Milestones")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/events"
    }
  }, [_vm._v("Log Events")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/config"
    }
  }, [_vm._v("Configuration")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Students"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/students"
    }
  }, [_vm._v("Students Overview")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/contracts"
    }
  }, [_vm._v("Contracts Overview")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Invoicing"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/planned"
    }
  }, [_vm._v("Planned Invoices")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/numbered"
    }
  }, [_vm._v("Numbered Invoices")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/creditnote"
    }
  }, [_vm._v("Credit Notes")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoicepayments"
    }
  }, [_vm._v("Invoice Payments")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Payments"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/scholarshippayments/planned"
    }
  }, [_vm._v("Planned Payments")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/scholarshippayments/numbered"
    }
  }, [_vm._v("Numbered Payments")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "userinfo"
  }, [_vm._v(_vm._s(_vm.userInfo))]), _vm._v(" "), _c('p', {
    staticClass: "versioninfo"
  }, [_vm._v(_vm._s(_vm.versionInfo))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$auth.logout();
        _vm.$router.push('/login')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice Number",
            "field": "number",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isPlanned && !_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Reference",
            "field": "document_reference",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Contract/Student",
            "field": "contract_id",
            "optionListApiUrl": '/contracts/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Year",
            "field": "year",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Semester",
            "field": "semester",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || (_vm.isEdit && !_vm.isPlanned),
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Linked to",
            "field": "linked_invoice_number",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice Date",
            "field": "invoice_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Date",
            "field": "planned_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": _vm.isPlanned ? 'required' : 'ok',
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Expiration Date",
            "field": "expiration_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Extended Deadline Date",
            "field": "extended_deadline_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount to be paid",
            "field": "amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "money",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (_vm.isReadOnly) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount invoiced",
            "field": "total_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount paid",
            "field": "payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Pro Forma",
            "field": "pro_forma",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "PDF Creation",
            "field": "pdf_creation_timestamp",
            "field2": "pdf_creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Email",
            "field": "email_timestamp",
            "field2": "email_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isPlanned && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createPDF(props.rec)
            }
          }
        }, [_vm._v("Create Invoice")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadPDF(props.rec)
            }
          }
        }, [_vm._v("Download " + _vm._s(_vm.isCreditNote ? 'Credit Note' : 'Invoice'))]) : _vm._e(), _vm._v(" "), ((_vm.isNumbered || _vm.isCreditNote) && (props.rec.is_creditnote === false) && !props.rec.is_expired && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec, false)
            }
          }
        }, [_vm._v("Send Email")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && props.rec.document_type_id === 1 && props.rec.is_expired && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec, true)
            }
          }
        }, [_vm._v("Send Email Reminder")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createCreditNote(props.rec)
            }
          }
        }, [_vm._v(_vm._s(_vm.getCancelCommand(props.rec)))]) : _vm._e()], 2)]
      }
    }])
  }), _vm._v(" "), _c('b-modal', {
    ref: "modalCreditNote",
    attrs: {
      "size": "lg",
      "title": "CreditNote"
    },
    on: {
      "ok": _vm.okCreditNote
    }
  }, [_c('b-form', {
    ref: "cnform",
    staticClass: "col-md-8 offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.cnRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Description",
      "field": "description",
      "rec": _vm.cnRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalLinkRegistrationFee",
    attrs: {
      "size": "lg",
      "title": "Link Registration Fee",
      "ok-title": "Link"
    },
    on: {
      "ok": _vm.okLinkRegistrationFee
    }
  }, [_c('b-form', {
    ref: "lrfform",
    staticClass: "col-md-8 offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    ref: "lfrOptionList",
    staticClass: "col-md-12",
    attrs: {
      "label": "Registration Fee",
      "field": "registration_id",
      "optionListApiUrl": '/invoices/choice/',
      "optionListApiDoUpdate": false,
      "rec": _vm.lrfRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.dataValid && props.rec.active_contract_id) ? _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'contract',
                params: {
                  id: props.rec.active_contract_id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Contract\n    ")]) : _vm._e()]
      }
    }, {
      key: "FormLayout",
      fn: function(props) {
        return [(_vm.dataValid) ? _c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [_c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "Student Name & Info",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "First Name",
            "field": "first_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Name",
            "field": "last_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Street Address",
            "field": "address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "ZIP",
            "field": "zip",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "City",
            "field": "city",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Country",
            "field": "cntry_id",
            "optionListApiUrl": "/countries/choice/",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Birthday",
            "field": "birth_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "simpledate",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Gender",
            "field": "gender",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator,
            "optionList": ['Male', 'Female', 'Non-Binary']
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Citizenship 1",
            "field": "citizenship1_cntry_id",
            "optionListApiUrl": "/countries/choice/",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Citizenship 2",
            "field": "citizenship2_cntry_id",
            "optionListApiUrl": "/countries/choice/",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Phone",
            "field": "phone",
            "type": "phone",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Email Address",
            "field": "email_address",
            "type": "email",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required|email",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Passport Nr",
            "field": "passport_number",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Registration Fee Paid",
            "field": "registration_fee_payed",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Bank info requested",
            "field": "bankinfo_emailrequest_timestamp",
            "field2": "bankinfo_emailrequest_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Bank info updated",
            "field": "bankinfo_updated_timestamp",
            "field2": "bankinfo_updated_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "Bank Account Holder Name",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "First",
            "field": "payment_holder_first_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last",
            "field": "payment_holder_last_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "Bank Account Holder Address",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Street + nr",
            "field": "payment_holder_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Postal code/City",
            "field": "payment_holder_zip_city",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Country",
            "field": "payment_holder_cntry_id",
            "optionListApiUrl": "/countries/choice/",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "Bank Account",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "IBAN",
            "field": "payment_bank_iban",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Swift",
            "field": "payment_bank_swift",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Reference",
            "field": "payment_bank_reference",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "Bank & Addres",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Name",
            "field": "payment_bank_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Street + nr",
            "field": "payment_bank_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Postal code/City",
            "field": "payment_bank_zip_city",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Country",
            "field": "payment_bank_cntry_id",
            "optionListApiUrl": "/countries/choice/",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _c('b-card', {
          staticClass: "template-card",
          attrs: {
            "no-block": "",
            "header": "KIT Student Reference",
            "header-variant": "template-header"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Reference",
            "field": "university_payment_reference",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)]), _vm._v(" "), _vm._v(" -->\n    ")], 1) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Short Name",
            "field": "shortname",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Name",
            "field": "name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Registration Fee Amount",
            "field": "registration_fee_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 1",
            "field": "invoice1_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 2",
            "field": "invoice2_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 3",
            "field": "invoice3_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 4",
            "field": "invoice4_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Monthly Allowance",
            "field": "monthly_allowance_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/scholarship_payments/download_report', 'Payments.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCheckUniversityFeesOk.show()
            }
          }
        }, [_vm._v("Check University Fees")]), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentOk.show()
            }
          }
        }, [_vm._v("Export Payments")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/scholarship_payments/download_kit_report', 'KIT_Payments.xlsx')
            }
          }
        }, [_vm._v("Export KIT Payments")]) : _vm._e(), _vm._v(" "), (_vm.isPlanned && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCreatePaymentOk.show()
            }
          }
        }, [_vm._v("Schedule Payments")]) : _vm._e()], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privAdministrator) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), (_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSchedulePaymentOk.show()
            }
          }
        }, [_vm._v("Schedule Payments")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Contract - Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Planned before",
      "type": "date",
      "field": "planned_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y1",
      "field": "y1_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Exported after",
      "type": "date",
      "field": "exported_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Ready for export",
      "field": "ready_for_export",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Type",
      "field": "scholarship_payment_type_id",
      "optionListApiUrl": '/scholarship_payment_types/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalExportPaymentOk",
    attrs: {
      "title": "Export Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.exportPayments
    }
  }, [_vm._v("\n    Are you sure you want to export these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalSchedulePaymentOk",
    attrs: {
      "title": "Schedule Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.createBatchPayments, 'document_reference')
      }
    }
  }, [_vm._v("\n    Are you sure you want to schedule these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalCheckUniversityFeesOk",
    attrs: {
      "title": "Check University Fees",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.checkUniversityFees
    }
  }, [_vm._v("\n    Are you sure you want to check the university payments?\n    "), _c('b-form-fieldset', {
    attrs: {
      "label-text-align": "right",
      "label": "Period:",
      "horizontal": ""
    }
  }, [_c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": "universityFeePeriod",
      "type": "text"
    },
    model: {
      value: (_vm.universityFeePeriod),
      callback: function($$v) {
        _vm.universityFeePeriod = $$v
      },
      expression: "universityFeePeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalCreatePaymentOk",
    attrs: {
      "title": "Schedule Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.createPayments
    }
  }, [_vm._v("\n    Are you sure you want to schedule these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/scholarship_payments/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.bulkRec,
      "type": "money",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Payment Date",
      "field": "payment_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('bar-top'), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v("\n  " + _vm._s(_vm.serverVersion) + "\n  "), (Object.keys(this.config).length) ? _c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('b-tabs', {
    ref: "tabs",
    attrs: {
      "small": "",
      "card": ""
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Templates"
    }
  }, _vm._l((this.config.templates), function(templ, index) {
    return _c('b-card', {
      key: templ.id,
      staticClass: "template-card",
      attrs: {
        "no-block": "",
        "header": templ.displayname,
        "header-variant": "template-header"
      }
    }, [_c('div', {
      staticClass: "dlbuttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "default"
      },
      on: {
        "click": function($event) {
          _vm.downloadTemplate(templ)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "default",
        "disabled": !_vm.files[index]
      },
      on: {
        "click": function($event) {
          _vm.uploadTemplate(templ, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    }), _vm._v(" Upload")]), _vm._v(" "), _c('b-form-file', {
      ref: "fileinput",
      refInFor: true,
      attrs: {
        "placeholder": " "
      },
      model: {
        value: (_vm.files[index]),
        callback: function($$v) {
          _vm.$set(_vm.files, index, $$v)
        },
        expression: "files[index]"
      }
    })], 1)])
  })), _vm._v(" "), (_vm.privDeveloper) ? _c('b-tab', {
    attrs: {
      "title": "Email"
    }
  }, [_c('b-form', {
    ref: "formEmail",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', [_c('detail-field', {
    attrs: {
      "label": "SMTP Port",
      "field": "smtp_port",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Server",
      "field": "smtp_servername",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Username",
      "field": "smtp_username",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "ok",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Password",
      "field": "smtp_password",
      "rec": this.config.email_config,
      "type": "password",
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "ok",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Test Email",
      "field": "test_email_address",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "email",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "From: Email",
      "field": "from_email_address",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required|email",
      "validator": _vm.email_validator
    }
  })], 1)]), _vm._v(" "), (!_vm.editEmail) ? _c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        _vm.editEmail = !_vm.editEmail
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit")]) : _vm._e(), _vm._v(" "), (_vm.editEmail) ? _c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        _vm.saveEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]) : _vm._e()], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('bar-top')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.isReadOnly && _vm.dataValid && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (props.rec.contract_status_id === 2) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 1)
            }
          }
        }, [_vm._v("Accept Offer")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 1 || props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 2)
            }
          }
        }, [_vm._v("Reject Offer")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 1 || props.rec.contract_status_id === 2 || props.rec.contract_status_id === 4 || props.rec.contract_status_id === 6) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 3)
            }
          }
        }, [_vm._v("Enrole")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 4)
            }
          }
        }, [_vm._v("Take a break")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 5)
            }
          }
        }, [_vm._v("Graduate")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id > 2 && props.rec.contract_status_id < 6) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 6)
            }
          }
        }, [_vm._v("Drop-out")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentStatus.show()
            }
          }
        }, [_vm._v("Download PF Payment Status")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.checkSwitchToSemesterPayment(props.rec)
            }
          }
        }, [_vm._v("Switch to semester payment")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.requestPaymentInfo(props.rec)
            }
          }
        }, [_vm._v("Request payment info for refund")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadInvoiceDetails(props.rec)
            }
          }
        }, [_vm._v("Download Numbered Invoice Details")])], 2) : _vm._e(), _vm._v(" "), (props.rec.student_id) ? _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'student',
                params: {
                  id: props.rec.student_id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Student\n      ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('planned_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Planned Invoices\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('numbered_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Numbered Invoices\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('creditnote_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Credit Notes\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('invoicepayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Invoice Payments\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('planned_scholarshippayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Planned Payments\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('numbered_scholarshippayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Numbered Payments\n      ")])]
      }
    }, {
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-tabs', {
          ref: "tabs",
          attrs: {
            "small": "",
            "card": ""
          },
          model: {
            value: (_vm.tabIndex),
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        }, [_c('b-tab', {
          attrs: {
            "title": "General"
          }
        }, [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-0",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Student",
            "field": "student_id",
            "optionListApiUrl": '/students/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Application Number",
            "field": "application_number",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Intake",
            "field": "intake",
            "optionListApiUrl": '/contracts_intake/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Round",
            "field": "application_round",
            "optionList": ['0', '1', '2', '3', '4', '5'],
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Application ID",
            "field": "application_id",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Scholarship",
            "field": "scholarship_id",
            "optionListApiUrl": '/scholarships/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Status",
            "field": "contract_status_id",
            "optionListApiUrl": '/contract_status/choice/',
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Status Date",
            "field": "contract_status_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Program",
            "field": "program_id",
            "optionListApiUrl": '/programs/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "DA Application ID",
            "field": "da_application_id",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "DA Offer Status",
            "field": "da_offer_type",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "University Y1",
            "field": "y1_university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Y1 Finished",
            "field": "year1_finished",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Active",
            "field": "active",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "University Y2",
            "field": "y2_university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Y2 Finished",
            "field": "year2_finished",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Start Date",
            "field": "start_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onStartDateInput(props.rec, $event)
            }
          }
        }), _vm._v(" "), _c('detail-field', {
          ref: "enddate",
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "End Date",
            "field": "end_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Expected Graduation Date",
            "field": "expected_graduation_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [(!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Bank Info Required",
            "field": "bankinfo_required",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Check University Fee Payment",
            "field": "check_universityfee_payment",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Instalments",
            "field": "instalments",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Contract Sent",
            "field": "contract_sent_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Contract Signed",
            "field": "contract_signed_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoiced Amount",
            "field": "invoiced_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Paid Amount",
            "field": "payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "To Be Paid Amount",
            "field": "to_be_payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Amount",
            "field": "planned_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('b-tab', {
          attrs: {
            "title": 'Documents (' + ((_vm.dataValid && props.rec.files) ? props.rec.files.length : 0) + ')'
          }
        }, [(_vm.dataValid && props.rec.files) ? _c('div', _vm._l((props.rec.files), function(doc, index) {
          return _c('b-card', {
            key: doc.id,
            staticClass: "template-card"
          }, [_vm._v("\n                " + _vm._s(doc.filename)), _c('br'), _vm._v("\n                " + _vm._s(doc.description)), _c('br'), _vm._v(" "), _c('b-button', {
            on: {
              "click": function($event) {
                _vm.downloadDocument(doc)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-download"
          }), _vm._v(" Download")]), _vm._v(" "), (_vm.privUser) ? _c('b-button', {
            directives: [{
              name: "b-modal",
              rawName: "v-b-modal.modalDocDeleteOk",
              modifiers: {
                "modalDocDeleteOk": true
              }
            }],
            on: {
              "click": function($event) {
                _vm.activeDocument = doc
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          }), _vm._v(" Delete")]) : _vm._e()], 1)
        })) : _vm._e(), _vm._v(" "), (_vm.privUser) ? _c('b-card', [_c('b-form-file', {
          ref: "fileinput",
          attrs: {
            "placeholder": " "
          },
          model: {
            value: (_vm.documentToUpload),
            callback: function($$v) {
              _vm.documentToUpload = $$v
            },
            expression: "documentToUpload"
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "File Type",
            "field": "ft_id",
            "optionListApiUrl": '/file_types/choice/',
            "rec": _vm.fileRec,
            "isReadOnly": false,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": _vm.fileRec,
            "isReadOnly": false,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('b-button', {
          attrs: {
            "disabled": !_vm.documentToUpload
          },
          on: {
            "click": function($event) {
              _vm.uploadDocument(props.rec.id, _vm.documentToUpload)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        }), _vm._v(" Upload")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
          attrs: {
            "id": "modalDocDeleteOk",
            "title": "Delete Document",
            "ok-title": "Yes",
            "close-title": "No"
          },
          on: {
            "ok": _vm.deleteDocument
          }
        }, [_vm._v("\n      Are you sure you want to delete this document?\n    ")]), _vm._v(" "), _c('b-modal', {
          ref: "modalSwitchSemesterPaymentOk",
          attrs: {
            "title": "Switch to Semester Payment",
            "ok-title": "Yes",
            "close-title": "No"
          },
          on: {
            "ok": _vm.doSwitchToSemesterPayment
          }
        }, [_vm._v("\n      Are you sure to switch to semester payment?\n    ")]), _vm._v(" "), _c('b-modal', {
          ref: "modalExportPaymentStatus",
          attrs: {
            "size": "lg",
            "title": "Download PF Payment Status",
            "ok-title": "Download",
            "close-title": "Cancel",
            "ok-disabled": false
          },
          on: {
            "ok": function($event) {
              _vm.downloadPaymentStatus(props.rec)
            }
          }
        }, [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Simulation date for testing",
            "type": "date",
            "field": "simulation_date",
            "rec": _vm.downloadPaymentRec,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Code",
            "field": "cntry_code",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Name",
            "field": "cntry_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[356]);


// WEBPACK FOOTER //
// static/js/app.ba4717a58728b31700a6.js